
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { GeoTortueParserListener } from "./GeoTortueParserListener.js";
import { GeoTortueParserVisitor } from "./GeoTortueParserVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class GeoTortueParser extends antlr.Parser {
    public static readonly GT_FORWARD = 1;
    public static readonly GT_BACKWARD = 2;
    public static readonly GT_TURN_RIGHT = 3;
    public static readonly GT_TURN_LEFT = 4;
    public static readonly GT_CLEAR_GRAPHICS = 5;
    public static readonly GT_RESET = 6;
    public static readonly GT_UNDO_DRAWING = 7;
    public static readonly GT_HIDE_TURTLE = 8;
    public static readonly GT_SHOW_TURTLE = 9;
    public static readonly GT_PEN_UP = 10;
    public static readonly GT_PEN_DOWN = 11;
    public static readonly GT_PEN_COLOR = 12;
    public static readonly GT_PEN_THICKNESS = 13;
    public static readonly GT_DRAW_POINT = 14;
    public static readonly GT_MIRROR = 15;
    public static readonly GT_TELEPORT = 16;
    public static readonly GT_COMPASS = 17;
    public static readonly GT_AIM = 18;
    public static readonly GT_MIMIC = 19;
    public static readonly GT_ROTATE_RIGHT = 20;
    public static readonly GT_ROTATE_LEFT = 21;
    public static readonly GT_ROTATE_UP = 22;
    public static readonly GT_ROTATE_DOWN = 23;
    public static readonly GT_ROTATE_XY = 24;
    public static readonly GT_ROTATE_XZ = 25;
    public static readonly GT_ROTATE_YZ = 26;
    public static readonly GT_DRAW_CIRCLE = 27;
    public static readonly GT_DRAW_ARC = 28;
    public static readonly GT_PLAY = 29;
    public static readonly GT_SCORE = 30;
    public static readonly GT_CONCERT = 31;
    public static readonly GT_FILL = 32;
    public static readonly GT_WRITE = 33;
    public static readonly GT_SAY = 34;
    public static readonly GT_INIT = 35;
    public static readonly GT_WAIT = 36;
    public static readonly GT_PAUSE = 37;
    public static readonly GT_STOP = 38;
    public static readonly GT_RETURN = 39;
    public static readonly GT_MANIPULATE_GRAPH = 40;
    public static readonly GT_SNAPSHOT = 41;
    public static readonly GT_EXECUTE = 42;
    public static readonly GT_DELETE = 43;
    public static readonly GT_GLOBAL = 44;
    public static readonly GT_DISPLAY = 45;
    public static readonly GT_WRAP = 46;
    public static readonly GT_WINDOW = 47;
    public static readonly GT_FENCE = 48;
    public static readonly GT_REPEAT = 49;
    public static readonly GT_WHILE = 50;
    public static readonly GT_FOR_EACH = 51;
    public static readonly GT_FROM = 52;
    public static readonly GT_TO = 53;
    public static readonly GT_IN_LIST = 54;
    public static readonly GT_IF = 55;
    public static readonly GT_THEN = 56;
    public static readonly GT_ELSE = 57;
    public static readonly GT_SELECT = 58;
    public static readonly GT_FUNCTION_DEF = 59;
    public static readonly GT_ASK_FOR_VALUE = 60;
    public static readonly GT_PROCEDURE_START = 61;
    public static readonly GT_PROCEDURE_END = 62;
    public static readonly GT_IDENTIFIER = 63;
    public static readonly GT_WORD = 64;
    public static readonly GT_INTEGER_LITERAL = 65;
    public static readonly GT_FLOATING_POINT_LITERAL = 66;
    public static readonly GT_STRING_LITERAL = 67;
    public static readonly GT_STATEMENT_SEPARATOR = 68;
    public static readonly GT_ASSIGN = 69;
    public static readonly GT_COMMA = 70;
    public static readonly GT_LEFT_SQUARE_BRACKET = 71;
    public static readonly GT_RIGHT_SQUARE_BRACKET = 72;
    public static readonly GT_LEFT_PARENTHESIS = 73;
    public static readonly GT_RIGHT_PARENTHESIS = 74;
    public static readonly GT_COLON = 75;
    public static readonly GT_GREATER_THAN = 76;
    public static readonly GT_LESS_THAN = 77;
    public static readonly GT_EQUAL = 78;
    public static readonly GT_LESS_OR_EQUAL = 79;
    public static readonly GT_GREATER_OR_EQUAL = 80;
    public static readonly GT_NOT_EQUAL = 81;
    public static readonly GT_LOGICAL_AND = 82;
    public static readonly GT_LOGICAL_OR = 83;
    public static readonly GT_PLUS = 84;
    public static readonly GT_MINUS = 85;
    public static readonly GT_MULTIPLY = 86;
    public static readonly GT_DOT = 87;
    public static readonly GT_DIVIDE = 88;
    public static readonly GT_MODULO = 89;
    public static readonly GT_LOGICAL_NOT = 90;
    public static readonly GT_POWER = 91;
    public static readonly GT_CROSS_PRODUCT = 92;
    public static readonly GT_NEW_LINE = 93;
    public static readonly GT_HORIZONTAL_WHITESPACE = 94;
    public static readonly GT_LINE_COMMENT_HASH = 95;
    public static readonly GT_LINE_COMMENT_SLASH = 96;
    public static readonly GT_BLOCK_COMMENT = 97;
    public static readonly RULE_program = 0;
    public static readonly RULE_statement = 1;
    public static readonly RULE_procedureDefinition = 2;
    public static readonly RULE_procedureParameter = 3;
    public static readonly RULE_procedureBody = 4;
    public static readonly RULE_commandStatement = 5;
    public static readonly RULE_fixedArityZeroCommandStatement = 6;
    public static readonly RULE_fixedArityOneCommandStatement = 7;
    public static readonly RULE_fixedArityTwoCommandStatement = 8;
    public static readonly RULE_variableArityMarkerCommandStatement = 9;
    public static readonly RULE_structureStatement = 10;
    public static readonly RULE_repeatBlock = 11;
    public static readonly RULE_whileBlock = 12;
    public static readonly RULE_ifBlock = 13;
    public static readonly RULE_forEachBlock = 14;
    public static readonly RULE_functionDef = 15;
    public static readonly RULE_procedureCallStatement = 16;
    public static readonly RULE_commandArgument = 17;
    public static readonly RULE_commandBlock = 18;
    public static readonly RULE_expressionStatement = 19;
    public static readonly RULE_expression = 20;
    public static readonly RULE_assignExpression = 21;
    public static readonly RULE_rightExpression = 22;
    public static readonly RULE_logicalOrExpression = 23;
    public static readonly RULE_logicalAndExpression = 24;
    public static readonly RULE_equalityExpression = 25;
    public static readonly RULE_relationalExpression = 26;
    public static readonly RULE_additiveExpression = 27;
    public static readonly RULE_multiplicativeExpression = 28;
    public static readonly RULE_unaryExpression = 29;
    public static readonly RULE_powerExpression = 30;
    public static readonly RULE_unaryExpressionWithoutSign = 31;
    public static readonly RULE_sExpression = 32;
    public static readonly RULE_sExpressionOperator = 33;
    public static readonly RULE_listLiteral = 34;
    public static readonly RULE_lValue = 35;
    public static readonly RULE_arrayAccess = 36;
    public static readonly RULE_variable = 37;
    public static readonly RULE_functionCall = 38;
    public static readonly RULE_argumentList = 39;
    public static readonly RULE_constant = 40;
    public static readonly RULE_terminator = 41;

    public static readonly literalNames = [
        null, "'GT_FORWARD'", "'GT_BACKWARD'", "'GT_TURN_RIGHT'", "'GT_TURN_LEFT'", 
        "'GT_CLEAR_GRAPHICS'", "'GT_RESET'", "'GT_UNDO_DRAWING'", "'GT_HIDE_TURTLE'", 
        "'GT_SHOW_TURTLE'", "'GT_PEN_UP'", "'GT_PEN_DOWN'", "'GT_PEN_COLOR'", 
        "'GT_PEN_THICKNESS'", "'GT_DRAW_POINT'", "'GT_MIRROR'", "'GT_TELEPORT'", 
        "'GT_COMPASS'", "'GT_AIM'", "'GT_MIMIC'", "'GT_ROTATE_RIGHT'", "'GT_ROTATE_LEFT'", 
        "'GT_ROTATE_UP'", "'GT_ROTATE_DOWN'", "'GT_ROTATE_XY'", "'GT_ROTATE_XZ'", 
        "'GT_ROTATE_YZ'", "'GT_DRAW_CIRCLE'", "'GT_DRAW_ARC'", "'GT_PLAY'", 
        "'GT_SCORE'", "'GT_CONCERT'", "'GT_FILL'", "'GT_WRITE'", "'GT_SAY'", 
        "'GT_INIT'", "'GT_WAIT'", "'GT_PAUSE'", "'GT_STOP'", "'GT_RETURN'", 
        "'GT_MANIPULATE_GRAPH'", "'GT_SNAPSHOT'", "'GT_EXECUTE'", "'GT_DELETE'", 
        "'GT_GLOBAL'", "'GT_DISPLAY'", "'GT_WRAP'", "'GT_WINDOW'", "'GT_FENCE'", 
        "'GT_REPEAT'", "'GT_WHILE'", "'GT_FOR_EACH'", "'GT_FROM'", "'GT_TO'", 
        "'GT_IN_LIST'", "'GT_IF'", "'GT_THEN'", "'GT_ELSE'", "'GT_SELECT'", 
        "'GT_FUNCTION_DEF'", "'GT_ASK_FOR_VALUE'", "'GT_PROCEDURE_START'", 
        "'GT_PROCEDURE_END'", null, null, null, null, null, "';'", "':='", 
        "','", "'['", "']'", "'('", "')'", "':'", "'>'", "'<'", "'='", "'<='", 
        "'>='", "'!='", "'&&'", "'||'", "'+'", "'-'", "'*'", "'.'", "'/'", 
        "'%'", "'!'", "'^'", "'^^'"
    ];

    public static readonly symbolicNames = [
        null, "GT_FORWARD", "GT_BACKWARD", "GT_TURN_RIGHT", "GT_TURN_LEFT", 
        "GT_CLEAR_GRAPHICS", "GT_RESET", "GT_UNDO_DRAWING", "GT_HIDE_TURTLE", 
        "GT_SHOW_TURTLE", "GT_PEN_UP", "GT_PEN_DOWN", "GT_PEN_COLOR", "GT_PEN_THICKNESS", 
        "GT_DRAW_POINT", "GT_MIRROR", "GT_TELEPORT", "GT_COMPASS", "GT_AIM", 
        "GT_MIMIC", "GT_ROTATE_RIGHT", "GT_ROTATE_LEFT", "GT_ROTATE_UP", 
        "GT_ROTATE_DOWN", "GT_ROTATE_XY", "GT_ROTATE_XZ", "GT_ROTATE_YZ", 
        "GT_DRAW_CIRCLE", "GT_DRAW_ARC", "GT_PLAY", "GT_SCORE", "GT_CONCERT", 
        "GT_FILL", "GT_WRITE", "GT_SAY", "GT_INIT", "GT_WAIT", "GT_PAUSE", 
        "GT_STOP", "GT_RETURN", "GT_MANIPULATE_GRAPH", "GT_SNAPSHOT", "GT_EXECUTE", 
        "GT_DELETE", "GT_GLOBAL", "GT_DISPLAY", "GT_WRAP", "GT_WINDOW", 
        "GT_FENCE", "GT_REPEAT", "GT_WHILE", "GT_FOR_EACH", "GT_FROM", "GT_TO", 
        "GT_IN_LIST", "GT_IF", "GT_THEN", "GT_ELSE", "GT_SELECT", "GT_FUNCTION_DEF", 
        "GT_ASK_FOR_VALUE", "GT_PROCEDURE_START", "GT_PROCEDURE_END", "GT_IDENTIFIER", 
        "GT_WORD", "GT_INTEGER_LITERAL", "GT_FLOATING_POINT_LITERAL", "GT_STRING_LITERAL", 
        "GT_STATEMENT_SEPARATOR", "GT_ASSIGN", "GT_COMMA", "GT_LEFT_SQUARE_BRACKET", 
        "GT_RIGHT_SQUARE_BRACKET", "GT_LEFT_PARENTHESIS", "GT_RIGHT_PARENTHESIS", 
        "GT_COLON", "GT_GREATER_THAN", "GT_LESS_THAN", "GT_EQUAL", "GT_LESS_OR_EQUAL", 
        "GT_GREATER_OR_EQUAL", "GT_NOT_EQUAL", "GT_LOGICAL_AND", "GT_LOGICAL_OR", 
        "GT_PLUS", "GT_MINUS", "GT_MULTIPLY", "GT_DOT", "GT_DIVIDE", "GT_MODULO", 
        "GT_LOGICAL_NOT", "GT_POWER", "GT_CROSS_PRODUCT", "GT_NEW_LINE", 
        "GT_HORIZONTAL_WHITESPACE", "GT_LINE_COMMENT_HASH", "GT_LINE_COMMENT_SLASH", 
        "GT_BLOCK_COMMENT"
    ];
    public static readonly ruleNames = [
        "program", "statement", "procedureDefinition", "procedureParameter", 
        "procedureBody", "commandStatement", "fixedArityZeroCommandStatement", 
        "fixedArityOneCommandStatement", "fixedArityTwoCommandStatement", 
        "variableArityMarkerCommandStatement", "structureStatement", "repeatBlock", 
        "whileBlock", "ifBlock", "forEachBlock", "functionDef", "procedureCallStatement", 
        "commandArgument", "commandBlock", "expressionStatement", "expression", 
        "assignExpression", "rightExpression", "logicalOrExpression", "logicalAndExpression", 
        "equalityExpression", "relationalExpression", "additiveExpression", 
        "multiplicativeExpression", "unaryExpression", "powerExpression", 
        "unaryExpressionWithoutSign", "sExpression", "sExpressionOperator", 
        "listLiteral", "lValue", "arrayAccess", "variable", "functionCall", 
        "argumentList", "constant", "terminator",
    ];

    public get grammarFileName(): string { return "GeoTortueParser.g4"; }
    public get literalNames(): (string | null)[] { return GeoTortueParser.literalNames; }
    public get symbolicNames(): (string | null)[] { return GeoTortueParser.symbolicNames; }
    public get ruleNames(): string[] { return GeoTortueParser.ruleNames; }
    public get serializedATN(): number[] { return GeoTortueParser._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, GeoTortueParser._ATN, GeoTortueParser.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public program(): ProgramContext {
        let localContext = new ProgramContext(this.context, this.state);
        this.enterRule(localContext, 0, GeoTortueParser.RULE_program);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 87;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 0, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 84;
                    this.terminator();
                    }
                    }
                }
                this.state = 89;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 0, this.context);
            }
            this.state = 99;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294967294) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 3163553791) !== 0) || ((((_la - 65)) & ~0x1F) === 0 && ((1 << (_la - 65)) & 303564111) !== 0)) {
                {
                {
                this.state = 90;
                this.statement();
                this.state = 94;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 1, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 91;
                        this.terminator();
                        }
                        }
                    }
                    this.state = 96;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 1, this.context);
                }
                }
                }
                this.state = 101;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 102;
            this.match(GeoTortueParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public statement(): StatementContext {
        let localContext = new StatementContext(this.context, this.state);
        this.enterRule(localContext, 2, GeoTortueParser.RULE_statement);
        try {
            this.state = 109;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 3, this.context) ) {
            case 1:
                localContext = new ProcedureDefContext(localContext);
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 104;
                this.procedureDefinition();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 105;
                this.structureStatement();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 106;
                this.commandStatement();
                }
                break;
            case 4:
                localContext = new ProcedureCallContext(localContext);
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 107;
                this.procedureCallStatement();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 108;
                this.expressionStatement();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedureDefinition(): ProcedureDefinitionContext {
        let localContext = new ProcedureDefinitionContext(this.context, this.state);
        this.enterRule(localContext, 4, GeoTortueParser.RULE_procedureDefinition);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 114;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 68 || _la === 93) {
                {
                {
                this.state = 111;
                this.terminator();
                }
                }
                this.state = 116;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 117;
            this.match(GeoTortueParser.GT_PROCEDURE_START);
            this.state = 118;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            this.state = 122;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 5, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 119;
                    this.procedureParameter();
                    }
                    }
                }
                this.state = 124;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 5, this.context);
            }
            this.state = 128;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 6, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 125;
                    this.terminator();
                    }
                    }
                }
                this.state = 130;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 6, this.context);
            }
            this.state = 131;
            this.procedureBody();
            this.state = 132;
            this.match(GeoTortueParser.GT_PROCEDURE_END);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedureParameter(): ProcedureParameterContext {
        let localContext = new ProcedureParameterContext(this.context, this.state);
        this.enterRule(localContext, 6, GeoTortueParser.RULE_procedureParameter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 134;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedureBody(): ProcedureBodyContext {
        let localContext = new ProcedureBodyContext(this.context, this.state);
        this.enterRule(localContext, 8, GeoTortueParser.RULE_procedureBody);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 145;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294967294) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 3163553791) !== 0) || ((((_la - 65)) & ~0x1F) === 0 && ((1 << (_la - 65)) & 303564111) !== 0)) {
                {
                {
                this.state = 136;
                this.statement();
                this.state = 140;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 7, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 137;
                        this.terminator();
                        }
                        }
                    }
                    this.state = 142;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 7, this.context);
                }
                }
                }
                this.state = 147;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public commandStatement(): CommandStatementContext {
        let localContext = new CommandStatementContext(this.context, this.state);
        this.enterRule(localContext, 10, GeoTortueParser.RULE_commandStatement);
        try {
            this.state = 152;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_CLEAR_GRAPHICS:
            case GeoTortueParser.GT_RESET:
            case GeoTortueParser.GT_UNDO_DRAWING:
            case GeoTortueParser.GT_HIDE_TURTLE:
            case GeoTortueParser.GT_SHOW_TURTLE:
            case GeoTortueParser.GT_PEN_UP:
            case GeoTortueParser.GT_PEN_DOWN:
            case GeoTortueParser.GT_DRAW_POINT:
            case GeoTortueParser.GT_MIRROR:
            case GeoTortueParser.GT_COMPASS:
            case GeoTortueParser.GT_INIT:
            case GeoTortueParser.GT_WAIT:
            case GeoTortueParser.GT_STOP:
            case GeoTortueParser.GT_WRAP:
            case GeoTortueParser.GT_WINDOW:
            case GeoTortueParser.GT_FENCE:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 148;
                this.fixedArityZeroCommandStatement();
                }
                break;
            case GeoTortueParser.GT_FORWARD:
            case GeoTortueParser.GT_BACKWARD:
            case GeoTortueParser.GT_TURN_RIGHT:
            case GeoTortueParser.GT_TURN_LEFT:
            case GeoTortueParser.GT_PEN_COLOR:
            case GeoTortueParser.GT_PEN_THICKNESS:
            case GeoTortueParser.GT_AIM:
            case GeoTortueParser.GT_MIMIC:
            case GeoTortueParser.GT_ROTATE_RIGHT:
            case GeoTortueParser.GT_ROTATE_LEFT:
            case GeoTortueParser.GT_ROTATE_UP:
            case GeoTortueParser.GT_ROTATE_DOWN:
            case GeoTortueParser.GT_ROTATE_XY:
            case GeoTortueParser.GT_ROTATE_XZ:
            case GeoTortueParser.GT_ROTATE_YZ:
            case GeoTortueParser.GT_DRAW_CIRCLE:
            case GeoTortueParser.GT_FILL:
            case GeoTortueParser.GT_PAUSE:
            case GeoTortueParser.GT_RETURN:
            case GeoTortueParser.GT_MANIPULATE_GRAPH:
            case GeoTortueParser.GT_SNAPSHOT:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 149;
                this.fixedArityOneCommandStatement();
                }
                break;
            case GeoTortueParser.GT_DRAW_ARC:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 150;
                this.fixedArityTwoCommandStatement();
                }
                break;
            case GeoTortueParser.GT_TELEPORT:
            case GeoTortueParser.GT_PLAY:
            case GeoTortueParser.GT_SCORE:
            case GeoTortueParser.GT_CONCERT:
            case GeoTortueParser.GT_WRITE:
            case GeoTortueParser.GT_SAY:
            case GeoTortueParser.GT_EXECUTE:
            case GeoTortueParser.GT_DELETE:
            case GeoTortueParser.GT_GLOBAL:
            case GeoTortueParser.GT_DISPLAY:
            case GeoTortueParser.GT_SELECT:
            case GeoTortueParser.GT_ASK_FOR_VALUE:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 151;
                this.variableArityMarkerCommandStatement();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixedArityZeroCommandStatement(): FixedArityZeroCommandStatementContext {
        let localContext = new FixedArityZeroCommandStatementContext(this.context, this.state);
        this.enterRule(localContext, 12, GeoTortueParser.RULE_fixedArityZeroCommandStatement);
        try {
            this.state = 170;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_CLEAR_GRAPHICS:
                localContext = new ClearGraphicsContext(localContext);
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 154;
                this.match(GeoTortueParser.GT_CLEAR_GRAPHICS);
                }
                break;
            case GeoTortueParser.GT_RESET:
                localContext = new ResetContext(localContext);
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 155;
                this.match(GeoTortueParser.GT_RESET);
                }
                break;
            case GeoTortueParser.GT_HIDE_TURTLE:
                localContext = new HideTurtleContext(localContext);
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 156;
                this.match(GeoTortueParser.GT_HIDE_TURTLE);
                }
                break;
            case GeoTortueParser.GT_SHOW_TURTLE:
                localContext = new ShowTurtleContext(localContext);
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 157;
                this.match(GeoTortueParser.GT_SHOW_TURTLE);
                }
                break;
            case GeoTortueParser.GT_PEN_UP:
                localContext = new PenUpContext(localContext);
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 158;
                this.match(GeoTortueParser.GT_PEN_UP);
                }
                break;
            case GeoTortueParser.GT_PEN_DOWN:
                localContext = new PenDownContext(localContext);
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 159;
                this.match(GeoTortueParser.GT_PEN_DOWN);
                }
                break;
            case GeoTortueParser.GT_COMPASS:
                localContext = new CompassContext(localContext);
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 160;
                this.match(GeoTortueParser.GT_COMPASS);
                }
                break;
            case GeoTortueParser.GT_INIT:
                localContext = new InitContext(localContext);
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 161;
                this.match(GeoTortueParser.GT_INIT);
                }
                break;
            case GeoTortueParser.GT_WAIT:
                localContext = new WaitContext(localContext);
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 162;
                this.match(GeoTortueParser.GT_WAIT);
                }
                break;
            case GeoTortueParser.GT_STOP:
                localContext = new StopContext(localContext);
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 163;
                this.match(GeoTortueParser.GT_STOP);
                }
                break;
            case GeoTortueParser.GT_UNDO_DRAWING:
                localContext = new UndoDrawingContext(localContext);
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 164;
                this.match(GeoTortueParser.GT_UNDO_DRAWING);
                }
                break;
            case GeoTortueParser.GT_DRAW_POINT:
                localContext = new DrawPointContext(localContext);
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 165;
                this.match(GeoTortueParser.GT_DRAW_POINT);
                }
                break;
            case GeoTortueParser.GT_MIRROR:
                localContext = new MirrorContext(localContext);
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 166;
                this.match(GeoTortueParser.GT_MIRROR);
                }
                break;
            case GeoTortueParser.GT_WRAP:
                localContext = new WrapModeContext(localContext);
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 167;
                this.match(GeoTortueParser.GT_WRAP);
                }
                break;
            case GeoTortueParser.GT_WINDOW:
                localContext = new WindowModeContext(localContext);
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 168;
                this.match(GeoTortueParser.GT_WINDOW);
                }
                break;
            case GeoTortueParser.GT_FENCE:
                localContext = new FenceModeContext(localContext);
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 169;
                this.match(GeoTortueParser.GT_FENCE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixedArityOneCommandStatement(): FixedArityOneCommandStatementContext {
        let localContext = new FixedArityOneCommandStatementContext(this.context, this.state);
        this.enterRule(localContext, 14, GeoTortueParser.RULE_fixedArityOneCommandStatement);
        try {
            this.state = 214;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_FORWARD:
                localContext = new MoveForwardContext(localContext);
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 172;
                this.match(GeoTortueParser.GT_FORWARD);
                this.state = 173;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_BACKWARD:
                localContext = new MoveBackwardContext(localContext);
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 174;
                this.match(GeoTortueParser.GT_BACKWARD);
                this.state = 175;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_TURN_RIGHT:
                localContext = new TurnRightContext(localContext);
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 176;
                this.match(GeoTortueParser.GT_TURN_RIGHT);
                this.state = 177;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_TURN_LEFT:
                localContext = new TurnLeftContext(localContext);
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 178;
                this.match(GeoTortueParser.GT_TURN_LEFT);
                this.state = 179;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_PEN_THICKNESS:
                localContext = new PenThicknessContext(localContext);
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 180;
                this.match(GeoTortueParser.GT_PEN_THICKNESS);
                this.state = 181;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_PEN_COLOR:
                localContext = new PenColorContext(localContext);
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 182;
                this.match(GeoTortueParser.GT_PEN_COLOR);
                this.state = 183;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_AIM:
                localContext = new AimContext(localContext);
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 184;
                this.match(GeoTortueParser.GT_AIM);
                this.state = 185;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_MIMIC:
                localContext = new MimicContext(localContext);
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 186;
                this.match(GeoTortueParser.GT_MIMIC);
                this.state = 187;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_PAUSE:
                localContext = new PauseContext(localContext);
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 188;
                this.match(GeoTortueParser.GT_PAUSE);
                this.state = 189;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_UP:
                localContext = new RotateUpContext(localContext);
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 190;
                this.match(GeoTortueParser.GT_ROTATE_UP);
                this.state = 191;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_DOWN:
                localContext = new RotateDownContext(localContext);
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 192;
                this.match(GeoTortueParser.GT_ROTATE_DOWN);
                this.state = 193;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_RIGHT:
                localContext = new RotateRightContext(localContext);
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 194;
                this.match(GeoTortueParser.GT_ROTATE_RIGHT);
                this.state = 195;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_LEFT:
                localContext = new RotateLeftContext(localContext);
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 196;
                this.match(GeoTortueParser.GT_ROTATE_LEFT);
                this.state = 197;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_XY:
                localContext = new RotateXYContext(localContext);
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 198;
                this.match(GeoTortueParser.GT_ROTATE_XY);
                this.state = 199;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_XZ:
                localContext = new RotateXZContext(localContext);
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 200;
                this.match(GeoTortueParser.GT_ROTATE_XZ);
                this.state = 201;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_ROTATE_YZ:
                localContext = new RotateYZContext(localContext);
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 202;
                this.match(GeoTortueParser.GT_ROTATE_YZ);
                this.state = 203;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_SNAPSHOT:
                localContext = new SnapshotContext(localContext);
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 204;
                this.match(GeoTortueParser.GT_SNAPSHOT);
                this.state = 205;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_RETURN:
                localContext = new ReturnContext(localContext);
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 206;
                this.match(GeoTortueParser.GT_RETURN);
                this.state = 207;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_DRAW_CIRCLE:
                localContext = new DrawCircleContext(localContext);
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 208;
                this.match(GeoTortueParser.GT_DRAW_CIRCLE);
                this.state = 209;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_FILL:
                localContext = new FillContext(localContext);
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 210;
                this.match(GeoTortueParser.GT_FILL);
                this.state = 211;
                this.commandArgument();
                }
                break;
            case GeoTortueParser.GT_MANIPULATE_GRAPH:
                localContext = new ManipulateGraphContext(localContext);
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 212;
                this.match(GeoTortueParser.GT_MANIPULATE_GRAPH);
                this.state = 213;
                this.commandArgument();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixedArityTwoCommandStatement(): FixedArityTwoCommandStatementContext {
        let localContext = new FixedArityTwoCommandStatementContext(this.context, this.state);
        this.enterRule(localContext, 16, GeoTortueParser.RULE_fixedArityTwoCommandStatement);
        try {
            localContext = new DrawArcContext(localContext);
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 216;
            this.match(GeoTortueParser.GT_DRAW_ARC);
            this.state = 217;
            this.commandArgument();
            this.state = 218;
            this.commandArgument();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public variableArityMarkerCommandStatement(): VariableArityMarkerCommandStatementContext {
        let localContext = new VariableArityMarkerCommandStatementContext(this.context, this.state);
        this.enterRule(localContext, 18, GeoTortueParser.RULE_variableArityMarkerCommandStatement);
        try {
            let alternative: number;
            this.state = 304;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_TELEPORT:
                localContext = new TeleportContext(localContext);
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 220;
                this.match(GeoTortueParser.GT_TELEPORT);
                this.state = 224;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 12, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 221;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 226;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 12, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_SELECT:
                localContext = new SelectContext(localContext);
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 227;
                this.match(GeoTortueParser.GT_SELECT);
                this.state = 231;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 13, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 228;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 233;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 13, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_DELETE:
                localContext = new DeleteContext(localContext);
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 234;
                this.match(GeoTortueParser.GT_DELETE);
                this.state = 238;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 14, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 235;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 240;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 14, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_DISPLAY:
                localContext = new DisplayContext(localContext);
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 241;
                this.match(GeoTortueParser.GT_DISPLAY);
                this.state = 245;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 15, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 242;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 247;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 15, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_WRITE:
                localContext = new WriteContext(localContext);
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 248;
                this.match(GeoTortueParser.GT_WRITE);
                this.state = 252;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 16, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 249;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 254;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 16, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_SAY:
                localContext = new SayContext(localContext);
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 255;
                this.match(GeoTortueParser.GT_SAY);
                this.state = 259;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 17, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 256;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 261;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 17, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_EXECUTE:
                localContext = new ExecuteContext(localContext);
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 262;
                this.match(GeoTortueParser.GT_EXECUTE);
                this.state = 266;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 18, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 263;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 268;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 18, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_PLAY:
                localContext = new PlayMusicContext(localContext);
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 269;
                this.match(GeoTortueParser.GT_PLAY);
                this.state = 273;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 19, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 270;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 275;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 19, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_SCORE:
                localContext = new ScoreContext(localContext);
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 276;
                this.match(GeoTortueParser.GT_SCORE);
                this.state = 280;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 20, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 277;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 282;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 20, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_CONCERT:
                localContext = new ConcertContext(localContext);
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 283;
                this.match(GeoTortueParser.GT_CONCERT);
                this.state = 287;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 21, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 284;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 289;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 21, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_ASK_FOR_VALUE:
                localContext = new AskForValueContext(localContext);
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 290;
                this.match(GeoTortueParser.GT_ASK_FOR_VALUE);
                this.state = 294;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 22, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 291;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 296;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 22, this.context);
                }
                }
                break;
            case GeoTortueParser.GT_GLOBAL:
                localContext = new GlobalContext(localContext);
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 297;
                this.match(GeoTortueParser.GT_GLOBAL);
                this.state = 301;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 23, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 298;
                        this.commandArgument();
                        }
                        }
                    }
                    this.state = 303;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 23, this.context);
                }
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public structureStatement(): StructureStatementContext {
        let localContext = new StructureStatementContext(this.context, this.state);
        this.enterRule(localContext, 20, GeoTortueParser.RULE_structureStatement);
        try {
            this.state = 311;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_REPEAT:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 306;
                this.repeatBlock();
                }
                break;
            case GeoTortueParser.GT_WHILE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 307;
                this.whileBlock();
                }
                break;
            case GeoTortueParser.GT_IF:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 308;
                this.ifBlock();
                }
                break;
            case GeoTortueParser.GT_FOR_EACH:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 309;
                this.forEachBlock();
                }
                break;
            case GeoTortueParser.GT_FUNCTION_DEF:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 310;
                this.functionDef();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public repeatBlock(): RepeatBlockContext {
        let localContext = new RepeatBlockContext(this.context, this.state);
        this.enterRule(localContext, 22, GeoTortueParser.RULE_repeatBlock);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 313;
            this.match(GeoTortueParser.GT_REPEAT);
            this.state = 314;
            this.expression();
            this.state = 315;
            this.commandBlock();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public whileBlock(): WhileBlockContext {
        let localContext = new WhileBlockContext(this.context, this.state);
        this.enterRule(localContext, 24, GeoTortueParser.RULE_whileBlock);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 317;
            this.match(GeoTortueParser.GT_WHILE);
            this.state = 318;
            this.expression();
            this.state = 319;
            this.commandBlock();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public ifBlock(): IfBlockContext {
        let localContext = new IfBlockContext(this.context, this.state);
        this.enterRule(localContext, 26, GeoTortueParser.RULE_ifBlock);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 321;
            this.match(GeoTortueParser.GT_IF);
            this.state = 322;
            this.expression();
            this.state = 324;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 56) {
                {
                this.state = 323;
                this.match(GeoTortueParser.GT_THEN);
                }
            }

            this.state = 326;
            this.commandBlock();
            this.state = 329;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 57) {
                {
                this.state = 327;
                this.match(GeoTortueParser.GT_ELSE);
                this.state = 328;
                this.commandBlock();
                }
            }

            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public forEachBlock(): ForEachBlockContext {
        let localContext = new ForEachBlockContext(this.context, this.state);
        this.enterRule(localContext, 28, GeoTortueParser.RULE_forEachBlock);
        try {
            this.state = 345;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 28, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 331;
                this.match(GeoTortueParser.GT_FOR_EACH);
                this.state = 332;
                this.match(GeoTortueParser.GT_IDENTIFIER);
                this.state = 333;
                this.match(GeoTortueParser.GT_IN_LIST);
                this.state = 334;
                this.expression();
                this.state = 335;
                this.commandBlock();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 337;
                this.match(GeoTortueParser.GT_FOR_EACH);
                this.state = 338;
                this.match(GeoTortueParser.GT_IDENTIFIER);
                this.state = 339;
                this.match(GeoTortueParser.GT_FROM);
                this.state = 340;
                this.expression();
                this.state = 341;
                this.match(GeoTortueParser.GT_TO);
                this.state = 342;
                this.expression();
                this.state = 343;
                this.commandBlock();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public functionDef(): FunctionDefContext {
        let localContext = new FunctionDefContext(this.context, this.state);
        this.enterRule(localContext, 30, GeoTortueParser.RULE_functionDef);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 347;
            this.match(GeoTortueParser.GT_FUNCTION_DEF);
            this.state = 348;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            this.state = 349;
            this.match(GeoTortueParser.GT_LEFT_PARENTHESIS);
            this.state = 358;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 63) {
                {
                this.state = 350;
                this.match(GeoTortueParser.GT_IDENTIFIER);
                this.state = 355;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                while (_la === 70) {
                    {
                    {
                    this.state = 351;
                    this.match(GeoTortueParser.GT_COMMA);
                    this.state = 352;
                    this.match(GeoTortueParser.GT_IDENTIFIER);
                    }
                    }
                    this.state = 357;
                    this.errorHandler.sync(this);
                    _la = this.tokenStream.LA(1);
                }
                }
            }

            this.state = 360;
            this.match(GeoTortueParser.GT_RIGHT_PARENTHESIS);
            this.state = 361;
            this.match(GeoTortueParser.GT_ASSIGN);
            this.state = 362;
            this.expression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedureCallStatement(): ProcedureCallStatementContext {
        let localContext = new ProcedureCallStatementContext(this.context, this.state);
        this.enterRule(localContext, 32, GeoTortueParser.RULE_procedureCallStatement);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 364;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            this.state = 368;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 31, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 365;
                    this.commandArgument();
                    }
                    }
                }
                this.state = 370;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 31, this.context);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public commandArgument(): CommandArgumentContext {
        let localContext = new CommandArgumentContext(this.context, this.state);
        this.enterRule(localContext, 34, GeoTortueParser.RULE_commandArgument);
        try {
            this.state = 373;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 32, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 371;
                this.commandBlock();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 372;
                this.expression();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public commandBlock(): CommandBlockContext {
        let localContext = new CommandBlockContext(this.context, this.state);
        this.enterRule(localContext, 36, GeoTortueParser.RULE_commandBlock);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 375;
            this.match(GeoTortueParser.GT_LEFT_SQUARE_BRACKET);
            this.state = 379;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 33, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 376;
                    this.terminator();
                    }
                    }
                }
                this.state = 381;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 33, this.context);
            }
            this.state = 391;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294967294) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 3163553791) !== 0) || ((((_la - 65)) & ~0x1F) === 0 && ((1 << (_la - 65)) & 303564111) !== 0)) {
                {
                {
                this.state = 382;
                this.statement();
                this.state = 386;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 34, this.context);
                while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                    if (alternative === 1) {
                        {
                        {
                        this.state = 383;
                        this.terminator();
                        }
                        }
                    }
                    this.state = 388;
                    this.errorHandler.sync(this);
                    alternative = this.interpreter.adaptivePredict(this.tokenStream, 34, this.context);
                }
                }
                }
                this.state = 393;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 394;
            this.match(GeoTortueParser.GT_RIGHT_SQUARE_BRACKET);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public expressionStatement(): ExpressionStatementContext {
        let localContext = new ExpressionStatementContext(this.context, this.state);
        this.enterRule(localContext, 38, GeoTortueParser.RULE_expressionStatement);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 396;
            this.expression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public expression(): ExpressionContext {
        let localContext = new ExpressionContext(this.context, this.state);
        this.enterRule(localContext, 40, GeoTortueParser.RULE_expression);
        try {
            this.state = 400;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 36, this.context) ) {
            case 1:
                localContext = new VarAssignmentContext(localContext);
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 398;
                this.assignExpression();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 399;
                this.rightExpression();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public assignExpression(): AssignExpressionContext {
        let localContext = new AssignExpressionContext(this.context, this.state);
        this.enterRule(localContext, 42, GeoTortueParser.RULE_assignExpression);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 402;
            this.lValue();
            this.state = 403;
            this.match(GeoTortueParser.GT_ASSIGN);
            this.state = 404;
            this.expression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rightExpression(): RightExpressionContext {
        let localContext = new RightExpressionContext(this.context, this.state);
        this.enterRule(localContext, 44, GeoTortueParser.RULE_rightExpression);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 406;
            this.logicalOrExpression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public logicalOrExpression(): LogicalOrExpressionContext {
        let localContext = new LogicalOrExpressionContext(this.context, this.state);
        this.enterRule(localContext, 46, GeoTortueParser.RULE_logicalOrExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 408;
            this.logicalAndExpression();
            this.state = 413;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 83) {
                {
                {
                this.state = 409;
                this.match(GeoTortueParser.GT_LOGICAL_OR);
                this.state = 410;
                this.logicalAndExpression();
                }
                }
                this.state = 415;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public logicalAndExpression(): LogicalAndExpressionContext {
        let localContext = new LogicalAndExpressionContext(this.context, this.state);
        this.enterRule(localContext, 48, GeoTortueParser.RULE_logicalAndExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 416;
            this.equalityExpression();
            this.state = 421;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 82) {
                {
                {
                this.state = 417;
                this.match(GeoTortueParser.GT_LOGICAL_AND);
                this.state = 418;
                this.equalityExpression();
                }
                }
                this.state = 423;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public equalityExpression(): EqualityExpressionContext {
        let localContext = new EqualityExpressionContext(this.context, this.state);
        this.enterRule(localContext, 50, GeoTortueParser.RULE_equalityExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 424;
            this.relationalExpression();
            this.state = 429;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 78 || _la === 81) {
                {
                {
                this.state = 425;
                _la = this.tokenStream.LA(1);
                if(!(_la === 78 || _la === 81)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 426;
                this.relationalExpression();
                }
                }
                this.state = 431;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public relationalExpression(): RelationalExpressionContext {
        let localContext = new RelationalExpressionContext(this.context, this.state);
        this.enterRule(localContext, 52, GeoTortueParser.RULE_relationalExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 432;
            this.additiveExpression();
            this.state = 437;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (((((_la - 76)) & ~0x1F) === 0 && ((1 << (_la - 76)) & 27) !== 0)) {
                {
                {
                this.state = 433;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 76)) & ~0x1F) === 0 && ((1 << (_la - 76)) & 27) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 434;
                this.additiveExpression();
                }
                }
                this.state = 439;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public additiveExpression(): AdditiveExpressionContext {
        let localContext = new AdditiveExpressionContext(this.context, this.state);
        this.enterRule(localContext, 54, GeoTortueParser.RULE_additiveExpression);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 440;
            this.multiplicativeExpression();
            this.state = 445;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 41, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    {
                    this.state = 441;
                    _la = this.tokenStream.LA(1);
                    if(!(_la === 84 || _la === 85)) {
                    this.errorHandler.recoverInline(this);
                    }
                    else {
                        this.errorHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 442;
                    this.multiplicativeExpression();
                    }
                    }
                }
                this.state = 447;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 41, this.context);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public multiplicativeExpression(): MultiplicativeExpressionContext {
        let localContext = new MultiplicativeExpressionContext(this.context, this.state);
        this.enterRule(localContext, 56, GeoTortueParser.RULE_multiplicativeExpression);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 448;
            this.unaryExpression();
            this.state = 454;
            this.errorHandler.sync(this);
            alternative = this.interpreter.adaptivePredict(this.tokenStream, 43, this.context);
            while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER) {
                if (alternative === 1) {
                    {
                    this.state = 452;
                    this.errorHandler.sync(this);
                    switch (this.tokenStream.LA(1)) {
                    case GeoTortueParser.GT_MULTIPLY:
                    case GeoTortueParser.GT_DOT:
                    case GeoTortueParser.GT_DIVIDE:
                    case GeoTortueParser.GT_MODULO:
                    case GeoTortueParser.GT_CROSS_PRODUCT:
                        {
                        this.state = 449;
                        _la = this.tokenStream.LA(1);
                        if(!(((((_la - 86)) & ~0x1F) === 0 && ((1 << (_la - 86)) & 79) !== 0))) {
                        this.errorHandler.recoverInline(this);
                        }
                        else {
                            this.errorHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 450;
                        this.unaryExpression();
                        }
                        break;
                    case GeoTortueParser.GT_IDENTIFIER:
                    case GeoTortueParser.GT_INTEGER_LITERAL:
                    case GeoTortueParser.GT_FLOATING_POINT_LITERAL:
                    case GeoTortueParser.GT_STRING_LITERAL:
                    case GeoTortueParser.GT_LEFT_SQUARE_BRACKET:
                    case GeoTortueParser.GT_LEFT_PARENTHESIS:
                    case GeoTortueParser.GT_COLON:
                        {
                        this.state = 451;
                        this.powerExpression();
                        }
                        break;
                    default:
                        throw new antlr.NoViableAltException(this);
                    }
                    }
                }
                this.state = 456;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 43, this.context);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unaryExpression(): UnaryExpressionContext {
        let localContext = new UnaryExpressionContext(this.context, this.state);
        this.enterRule(localContext, 58, GeoTortueParser.RULE_unaryExpression);
        try {
            this.state = 464;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case GeoTortueParser.GT_PLUS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 457;
                this.match(GeoTortueParser.GT_PLUS);
                this.state = 458;
                this.unaryExpression();
                }
                break;
            case GeoTortueParser.GT_MINUS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 459;
                this.match(GeoTortueParser.GT_MINUS);
                this.state = 460;
                this.unaryExpression();
                }
                break;
            case GeoTortueParser.GT_LOGICAL_NOT:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 461;
                this.match(GeoTortueParser.GT_LOGICAL_NOT);
                this.state = 462;
                this.unaryExpression();
                }
                break;
            case GeoTortueParser.GT_IDENTIFIER:
            case GeoTortueParser.GT_INTEGER_LITERAL:
            case GeoTortueParser.GT_FLOATING_POINT_LITERAL:
            case GeoTortueParser.GT_STRING_LITERAL:
            case GeoTortueParser.GT_LEFT_SQUARE_BRACKET:
            case GeoTortueParser.GT_LEFT_PARENTHESIS:
            case GeoTortueParser.GT_COLON:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 463;
                this.powerExpression();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public powerExpression(): PowerExpressionContext {
        let localContext = new PowerExpressionContext(this.context, this.state);
        this.enterRule(localContext, 60, GeoTortueParser.RULE_powerExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 466;
            this.unaryExpressionWithoutSign();
            this.state = 469;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 91) {
                {
                this.state = 467;
                this.match(GeoTortueParser.GT_POWER);
                this.state = 468;
                this.unaryExpression();
                }
            }

            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unaryExpressionWithoutSign(): UnaryExpressionWithoutSignContext {
        let localContext = new UnaryExpressionWithoutSignContext(this.context, this.state);
        this.enterRule(localContext, 62, GeoTortueParser.RULE_unaryExpressionWithoutSign);
        try {
            this.state = 481;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 46, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 471;
                this.constant();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 472;
                this.arrayAccess();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 473;
                this.functionCall();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 474;
                this.variable();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 475;
                this.match(GeoTortueParser.GT_LEFT_PARENTHESIS);
                this.state = 476;
                this.expression();
                this.state = 477;
                this.match(GeoTortueParser.GT_RIGHT_PARENTHESIS);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 479;
                this.sExpression();
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 480;
                this.listLiteral();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sExpression(): SExpressionContext {
        let localContext = new SExpressionContext(this.context, this.state);
        this.enterRule(localContext, 64, GeoTortueParser.RULE_sExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 483;
            this.match(GeoTortueParser.GT_LEFT_PARENTHESIS);
            this.state = 484;
            this.sExpressionOperator();
            this.state = 486;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 485;
                this.expression();
                }
                }
                this.state = 488;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (((((_la - 63)) & ~0x1F) === 0 && ((1 << (_la - 63)) & 140514589) !== 0));
            this.state = 490;
            this.match(GeoTortueParser.GT_RIGHT_PARENTHESIS);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sExpressionOperator(): SExpressionOperatorContext {
        let localContext = new SExpressionOperatorContext(this.context, this.state);
        this.enterRule(localContext, 66, GeoTortueParser.RULE_sExpressionOperator);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 492;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 63)) & ~0x1F) === 0 && ((1 << (_la - 63)) & 520085505) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public listLiteral(): ListLiteralContext {
        let localContext = new ListLiteralContext(this.context, this.state);
        this.enterRule(localContext, 68, GeoTortueParser.RULE_listLiteral);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 494;
            this.match(GeoTortueParser.GT_LEFT_SQUARE_BRACKET);
            this.state = 495;
            this.expression();
            this.state = 500;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 70) {
                {
                {
                this.state = 496;
                this.match(GeoTortueParser.GT_COMMA);
                this.state = 497;
                this.expression();
                }
                }
                this.state = 502;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 503;
            this.match(GeoTortueParser.GT_RIGHT_SQUARE_BRACKET);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lValue(): LValueContext {
        let localContext = new LValueContext(this.context, this.state);
        this.enterRule(localContext, 70, GeoTortueParser.RULE_lValue);
        try {
            this.state = 507;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 49, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 505;
                this.arrayAccess();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 506;
                this.variable();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public arrayAccess(): ArrayAccessContext {
        let localContext = new ArrayAccessContext(this.context, this.state);
        this.enterRule(localContext, 72, GeoTortueParser.RULE_arrayAccess);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 509;
            this.variable();
            this.state = 510;
            this.listLiteral();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public variable(): VariableContext {
        let localContext = new VariableContext(this.context, this.state);
        this.enterRule(localContext, 74, GeoTortueParser.RULE_variable);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 513;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 75) {
                {
                this.state = 512;
                this.match(GeoTortueParser.GT_COLON);
                }
            }

            this.state = 515;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public functionCall(): FunctionCallContext {
        let localContext = new FunctionCallContext(this.context, this.state);
        this.enterRule(localContext, 76, GeoTortueParser.RULE_functionCall);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 517;
            this.match(GeoTortueParser.GT_IDENTIFIER);
            this.state = 518;
            this.match(GeoTortueParser.GT_LEFT_PARENTHESIS);
            this.state = 519;
            this.argumentList();
            this.state = 520;
            this.match(GeoTortueParser.GT_RIGHT_PARENTHESIS);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public argumentList(): ArgumentListContext {
        let localContext = new ArgumentListContext(this.context, this.state);
        this.enterRule(localContext, 78, GeoTortueParser.RULE_argumentList);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 530;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (((((_la - 63)) & ~0x1F) === 0 && ((1 << (_la - 63)) & 140514589) !== 0)) {
                {
                this.state = 522;
                this.expression();
                this.state = 527;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                while (_la === 70) {
                    {
                    {
                    this.state = 523;
                    this.match(GeoTortueParser.GT_COMMA);
                    this.state = 524;
                    this.expression();
                    }
                    }
                    this.state = 529;
                    this.errorHandler.sync(this);
                    _la = this.tokenStream.LA(1);
                }
                }
            }

            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public constant(): ConstantContext {
        let localContext = new ConstantContext(this.context, this.state);
        this.enterRule(localContext, 80, GeoTortueParser.RULE_constant);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 532;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 65)) & ~0x1F) === 0 && ((1 << (_la - 65)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public terminator(): TerminatorContext {
        let localContext = new TerminatorContext(this.context, this.state);
        this.enterRule(localContext, 82, GeoTortueParser.RULE_terminator);
        let _la: number;
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 535;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 534;
                    _la = this.tokenStream.LA(1);
                    if(!(_la === 68 || _la === 93)) {
                    this.errorHandler.recoverInline(this);
                    }
                    else {
                        this.errorHandler.reportMatch(this);
                        this.consume();
                    }
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 537;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 53, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,97,540,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,
        6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,13,
        2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,20,
        7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,
        2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,33,
        7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,39,
        2,40,7,40,2,41,7,41,1,0,5,0,86,8,0,10,0,12,0,89,9,0,1,0,1,0,5,0,
        93,8,0,10,0,12,0,96,9,0,5,0,98,8,0,10,0,12,0,101,9,0,1,0,1,0,1,1,
        1,1,1,1,1,1,1,1,3,1,110,8,1,1,2,5,2,113,8,2,10,2,12,2,116,9,2,1,
        2,1,2,1,2,5,2,121,8,2,10,2,12,2,124,9,2,1,2,5,2,127,8,2,10,2,12,
        2,130,9,2,1,2,1,2,1,2,1,3,1,3,1,4,1,4,5,4,139,8,4,10,4,12,4,142,
        9,4,5,4,144,8,4,10,4,12,4,147,9,4,1,5,1,5,1,5,1,5,3,5,153,8,5,1,
        6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,3,
        6,171,8,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,3,7,215,8,7,1,
        8,1,8,1,8,1,8,1,9,1,9,5,9,223,8,9,10,9,12,9,226,9,9,1,9,1,9,5,9,
        230,8,9,10,9,12,9,233,9,9,1,9,1,9,5,9,237,8,9,10,9,12,9,240,9,9,
        1,9,1,9,5,9,244,8,9,10,9,12,9,247,9,9,1,9,1,9,5,9,251,8,9,10,9,12,
        9,254,9,9,1,9,1,9,5,9,258,8,9,10,9,12,9,261,9,9,1,9,1,9,5,9,265,
        8,9,10,9,12,9,268,9,9,1,9,1,9,5,9,272,8,9,10,9,12,9,275,9,9,1,9,
        1,9,5,9,279,8,9,10,9,12,9,282,9,9,1,9,1,9,5,9,286,8,9,10,9,12,9,
        289,9,9,1,9,1,9,5,9,293,8,9,10,9,12,9,296,9,9,1,9,1,9,5,9,300,8,
        9,10,9,12,9,303,9,9,3,9,305,8,9,1,10,1,10,1,10,1,10,1,10,3,10,312,
        8,10,1,11,1,11,1,11,1,11,1,12,1,12,1,12,1,12,1,13,1,13,1,13,3,13,
        325,8,13,1,13,1,13,1,13,3,13,330,8,13,1,14,1,14,1,14,1,14,1,14,1,
        14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,3,14,346,8,14,1,15,1,
        15,1,15,1,15,1,15,1,15,5,15,354,8,15,10,15,12,15,357,9,15,3,15,359,
        8,15,1,15,1,15,1,15,1,15,1,16,1,16,5,16,367,8,16,10,16,12,16,370,
        9,16,1,17,1,17,3,17,374,8,17,1,18,1,18,5,18,378,8,18,10,18,12,18,
        381,9,18,1,18,1,18,5,18,385,8,18,10,18,12,18,388,9,18,5,18,390,8,
        18,10,18,12,18,393,9,18,1,18,1,18,1,19,1,19,1,20,1,20,3,20,401,8,
        20,1,21,1,21,1,21,1,21,1,22,1,22,1,23,1,23,1,23,5,23,412,8,23,10,
        23,12,23,415,9,23,1,24,1,24,1,24,5,24,420,8,24,10,24,12,24,423,9,
        24,1,25,1,25,1,25,5,25,428,8,25,10,25,12,25,431,9,25,1,26,1,26,1,
        26,5,26,436,8,26,10,26,12,26,439,9,26,1,27,1,27,1,27,5,27,444,8,
        27,10,27,12,27,447,9,27,1,28,1,28,1,28,1,28,5,28,453,8,28,10,28,
        12,28,456,9,28,1,29,1,29,1,29,1,29,1,29,1,29,1,29,3,29,465,8,29,
        1,30,1,30,1,30,3,30,470,8,30,1,31,1,31,1,31,1,31,1,31,1,31,1,31,
        1,31,1,31,1,31,3,31,482,8,31,1,32,1,32,1,32,4,32,487,8,32,11,32,
        12,32,488,1,32,1,32,1,33,1,33,1,34,1,34,1,34,1,34,5,34,499,8,34,
        10,34,12,34,502,9,34,1,34,1,34,1,35,1,35,3,35,508,8,35,1,36,1,36,
        1,36,1,37,3,37,514,8,37,1,37,1,37,1,38,1,38,1,38,1,38,1,38,1,39,
        1,39,1,39,5,39,526,8,39,10,39,12,39,529,9,39,3,39,531,8,39,1,40,
        1,40,1,41,4,41,536,8,41,11,41,12,41,537,1,41,0,0,42,0,2,4,6,8,10,
        12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,
        56,58,60,62,64,66,68,70,72,74,76,78,80,82,0,7,2,0,78,78,81,81,2,
        0,76,77,79,80,1,0,84,85,2,0,86,89,92,92,3,0,63,63,76,86,88,91,1,
        0,65,67,2,0,68,68,93,93,609,0,87,1,0,0,0,2,109,1,0,0,0,4,114,1,0,
        0,0,6,134,1,0,0,0,8,145,1,0,0,0,10,152,1,0,0,0,12,170,1,0,0,0,14,
        214,1,0,0,0,16,216,1,0,0,0,18,304,1,0,0,0,20,311,1,0,0,0,22,313,
        1,0,0,0,24,317,1,0,0,0,26,321,1,0,0,0,28,345,1,0,0,0,30,347,1,0,
        0,0,32,364,1,0,0,0,34,373,1,0,0,0,36,375,1,0,0,0,38,396,1,0,0,0,
        40,400,1,0,0,0,42,402,1,0,0,0,44,406,1,0,0,0,46,408,1,0,0,0,48,416,
        1,0,0,0,50,424,1,0,0,0,52,432,1,0,0,0,54,440,1,0,0,0,56,448,1,0,
        0,0,58,464,1,0,0,0,60,466,1,0,0,0,62,481,1,0,0,0,64,483,1,0,0,0,
        66,492,1,0,0,0,68,494,1,0,0,0,70,507,1,0,0,0,72,509,1,0,0,0,74,513,
        1,0,0,0,76,517,1,0,0,0,78,530,1,0,0,0,80,532,1,0,0,0,82,535,1,0,
        0,0,84,86,3,82,41,0,85,84,1,0,0,0,86,89,1,0,0,0,87,85,1,0,0,0,87,
        88,1,0,0,0,88,99,1,0,0,0,89,87,1,0,0,0,90,94,3,2,1,0,91,93,3,82,
        41,0,92,91,1,0,0,0,93,96,1,0,0,0,94,92,1,0,0,0,94,95,1,0,0,0,95,
        98,1,0,0,0,96,94,1,0,0,0,97,90,1,0,0,0,98,101,1,0,0,0,99,97,1,0,
        0,0,99,100,1,0,0,0,100,102,1,0,0,0,101,99,1,0,0,0,102,103,5,0,0,
        1,103,1,1,0,0,0,104,110,3,4,2,0,105,110,3,20,10,0,106,110,3,10,5,
        0,107,110,3,32,16,0,108,110,3,38,19,0,109,104,1,0,0,0,109,105,1,
        0,0,0,109,106,1,0,0,0,109,107,1,0,0,0,109,108,1,0,0,0,110,3,1,0,
        0,0,111,113,3,82,41,0,112,111,1,0,0,0,113,116,1,0,0,0,114,112,1,
        0,0,0,114,115,1,0,0,0,115,117,1,0,0,0,116,114,1,0,0,0,117,118,5,
        61,0,0,118,122,5,63,0,0,119,121,3,6,3,0,120,119,1,0,0,0,121,124,
        1,0,0,0,122,120,1,0,0,0,122,123,1,0,0,0,123,128,1,0,0,0,124,122,
        1,0,0,0,125,127,3,82,41,0,126,125,1,0,0,0,127,130,1,0,0,0,128,126,
        1,0,0,0,128,129,1,0,0,0,129,131,1,0,0,0,130,128,1,0,0,0,131,132,
        3,8,4,0,132,133,5,62,0,0,133,5,1,0,0,0,134,135,5,63,0,0,135,7,1,
        0,0,0,136,140,3,2,1,0,137,139,3,82,41,0,138,137,1,0,0,0,139,142,
        1,0,0,0,140,138,1,0,0,0,140,141,1,0,0,0,141,144,1,0,0,0,142,140,
        1,0,0,0,143,136,1,0,0,0,144,147,1,0,0,0,145,143,1,0,0,0,145,146,
        1,0,0,0,146,9,1,0,0,0,147,145,1,0,0,0,148,153,3,12,6,0,149,153,3,
        14,7,0,150,153,3,16,8,0,151,153,3,18,9,0,152,148,1,0,0,0,152,149,
        1,0,0,0,152,150,1,0,0,0,152,151,1,0,0,0,153,11,1,0,0,0,154,171,5,
        5,0,0,155,171,5,6,0,0,156,171,5,8,0,0,157,171,5,9,0,0,158,171,5,
        10,0,0,159,171,5,11,0,0,160,171,5,17,0,0,161,171,5,35,0,0,162,171,
        5,36,0,0,163,171,5,38,0,0,164,171,5,7,0,0,165,171,5,14,0,0,166,171,
        5,15,0,0,167,171,5,46,0,0,168,171,5,47,0,0,169,171,5,48,0,0,170,
        154,1,0,0,0,170,155,1,0,0,0,170,156,1,0,0,0,170,157,1,0,0,0,170,
        158,1,0,0,0,170,159,1,0,0,0,170,160,1,0,0,0,170,161,1,0,0,0,170,
        162,1,0,0,0,170,163,1,0,0,0,170,164,1,0,0,0,170,165,1,0,0,0,170,
        166,1,0,0,0,170,167,1,0,0,0,170,168,1,0,0,0,170,169,1,0,0,0,171,
        13,1,0,0,0,172,173,5,1,0,0,173,215,3,34,17,0,174,175,5,2,0,0,175,
        215,3,34,17,0,176,177,5,3,0,0,177,215,3,34,17,0,178,179,5,4,0,0,
        179,215,3,34,17,0,180,181,5,13,0,0,181,215,3,34,17,0,182,183,5,12,
        0,0,183,215,3,34,17,0,184,185,5,18,0,0,185,215,3,34,17,0,186,187,
        5,19,0,0,187,215,3,34,17,0,188,189,5,37,0,0,189,215,3,34,17,0,190,
        191,5,22,0,0,191,215,3,34,17,0,192,193,5,23,0,0,193,215,3,34,17,
        0,194,195,5,20,0,0,195,215,3,34,17,0,196,197,5,21,0,0,197,215,3,
        34,17,0,198,199,5,24,0,0,199,215,3,34,17,0,200,201,5,25,0,0,201,
        215,3,34,17,0,202,203,5,26,0,0,203,215,3,34,17,0,204,205,5,41,0,
        0,205,215,3,34,17,0,206,207,5,39,0,0,207,215,3,34,17,0,208,209,5,
        27,0,0,209,215,3,34,17,0,210,211,5,32,0,0,211,215,3,34,17,0,212,
        213,5,40,0,0,213,215,3,34,17,0,214,172,1,0,0,0,214,174,1,0,0,0,214,
        176,1,0,0,0,214,178,1,0,0,0,214,180,1,0,0,0,214,182,1,0,0,0,214,
        184,1,0,0,0,214,186,1,0,0,0,214,188,1,0,0,0,214,190,1,0,0,0,214,
        192,1,0,0,0,214,194,1,0,0,0,214,196,1,0,0,0,214,198,1,0,0,0,214,
        200,1,0,0,0,214,202,1,0,0,0,214,204,1,0,0,0,214,206,1,0,0,0,214,
        208,1,0,0,0,214,210,1,0,0,0,214,212,1,0,0,0,215,15,1,0,0,0,216,217,
        5,28,0,0,217,218,3,34,17,0,218,219,3,34,17,0,219,17,1,0,0,0,220,
        224,5,16,0,0,221,223,3,34,17,0,222,221,1,0,0,0,223,226,1,0,0,0,224,
        222,1,0,0,0,224,225,1,0,0,0,225,305,1,0,0,0,226,224,1,0,0,0,227,
        231,5,58,0,0,228,230,3,34,17,0,229,228,1,0,0,0,230,233,1,0,0,0,231,
        229,1,0,0,0,231,232,1,0,0,0,232,305,1,0,0,0,233,231,1,0,0,0,234,
        238,5,43,0,0,235,237,3,34,17,0,236,235,1,0,0,0,237,240,1,0,0,0,238,
        236,1,0,0,0,238,239,1,0,0,0,239,305,1,0,0,0,240,238,1,0,0,0,241,
        245,5,45,0,0,242,244,3,34,17,0,243,242,1,0,0,0,244,247,1,0,0,0,245,
        243,1,0,0,0,245,246,1,0,0,0,246,305,1,0,0,0,247,245,1,0,0,0,248,
        252,5,33,0,0,249,251,3,34,17,0,250,249,1,0,0,0,251,254,1,0,0,0,252,
        250,1,0,0,0,252,253,1,0,0,0,253,305,1,0,0,0,254,252,1,0,0,0,255,
        259,5,34,0,0,256,258,3,34,17,0,257,256,1,0,0,0,258,261,1,0,0,0,259,
        257,1,0,0,0,259,260,1,0,0,0,260,305,1,0,0,0,261,259,1,0,0,0,262,
        266,5,42,0,0,263,265,3,34,17,0,264,263,1,0,0,0,265,268,1,0,0,0,266,
        264,1,0,0,0,266,267,1,0,0,0,267,305,1,0,0,0,268,266,1,0,0,0,269,
        273,5,29,0,0,270,272,3,34,17,0,271,270,1,0,0,0,272,275,1,0,0,0,273,
        271,1,0,0,0,273,274,1,0,0,0,274,305,1,0,0,0,275,273,1,0,0,0,276,
        280,5,30,0,0,277,279,3,34,17,0,278,277,1,0,0,0,279,282,1,0,0,0,280,
        278,1,0,0,0,280,281,1,0,0,0,281,305,1,0,0,0,282,280,1,0,0,0,283,
        287,5,31,0,0,284,286,3,34,17,0,285,284,1,0,0,0,286,289,1,0,0,0,287,
        285,1,0,0,0,287,288,1,0,0,0,288,305,1,0,0,0,289,287,1,0,0,0,290,
        294,5,60,0,0,291,293,3,34,17,0,292,291,1,0,0,0,293,296,1,0,0,0,294,
        292,1,0,0,0,294,295,1,0,0,0,295,305,1,0,0,0,296,294,1,0,0,0,297,
        301,5,44,0,0,298,300,3,34,17,0,299,298,1,0,0,0,300,303,1,0,0,0,301,
        299,1,0,0,0,301,302,1,0,0,0,302,305,1,0,0,0,303,301,1,0,0,0,304,
        220,1,0,0,0,304,227,1,0,0,0,304,234,1,0,0,0,304,241,1,0,0,0,304,
        248,1,0,0,0,304,255,1,0,0,0,304,262,1,0,0,0,304,269,1,0,0,0,304,
        276,1,0,0,0,304,283,1,0,0,0,304,290,1,0,0,0,304,297,1,0,0,0,305,
        19,1,0,0,0,306,312,3,22,11,0,307,312,3,24,12,0,308,312,3,26,13,0,
        309,312,3,28,14,0,310,312,3,30,15,0,311,306,1,0,0,0,311,307,1,0,
        0,0,311,308,1,0,0,0,311,309,1,0,0,0,311,310,1,0,0,0,312,21,1,0,0,
        0,313,314,5,49,0,0,314,315,3,40,20,0,315,316,3,36,18,0,316,23,1,
        0,0,0,317,318,5,50,0,0,318,319,3,40,20,0,319,320,3,36,18,0,320,25,
        1,0,0,0,321,322,5,55,0,0,322,324,3,40,20,0,323,325,5,56,0,0,324,
        323,1,0,0,0,324,325,1,0,0,0,325,326,1,0,0,0,326,329,3,36,18,0,327,
        328,5,57,0,0,328,330,3,36,18,0,329,327,1,0,0,0,329,330,1,0,0,0,330,
        27,1,0,0,0,331,332,5,51,0,0,332,333,5,63,0,0,333,334,5,54,0,0,334,
        335,3,40,20,0,335,336,3,36,18,0,336,346,1,0,0,0,337,338,5,51,0,0,
        338,339,5,63,0,0,339,340,5,52,0,0,340,341,3,40,20,0,341,342,5,53,
        0,0,342,343,3,40,20,0,343,344,3,36,18,0,344,346,1,0,0,0,345,331,
        1,0,0,0,345,337,1,0,0,0,346,29,1,0,0,0,347,348,5,59,0,0,348,349,
        5,63,0,0,349,358,5,73,0,0,350,355,5,63,0,0,351,352,5,70,0,0,352,
        354,5,63,0,0,353,351,1,0,0,0,354,357,1,0,0,0,355,353,1,0,0,0,355,
        356,1,0,0,0,356,359,1,0,0,0,357,355,1,0,0,0,358,350,1,0,0,0,358,
        359,1,0,0,0,359,360,1,0,0,0,360,361,5,74,0,0,361,362,5,69,0,0,362,
        363,3,40,20,0,363,31,1,0,0,0,364,368,5,63,0,0,365,367,3,34,17,0,
        366,365,1,0,0,0,367,370,1,0,0,0,368,366,1,0,0,0,368,369,1,0,0,0,
        369,33,1,0,0,0,370,368,1,0,0,0,371,374,3,36,18,0,372,374,3,40,20,
        0,373,371,1,0,0,0,373,372,1,0,0,0,374,35,1,0,0,0,375,379,5,71,0,
        0,376,378,3,82,41,0,377,376,1,0,0,0,378,381,1,0,0,0,379,377,1,0,
        0,0,379,380,1,0,0,0,380,391,1,0,0,0,381,379,1,0,0,0,382,386,3,2,
        1,0,383,385,3,82,41,0,384,383,1,0,0,0,385,388,1,0,0,0,386,384,1,
        0,0,0,386,387,1,0,0,0,387,390,1,0,0,0,388,386,1,0,0,0,389,382,1,
        0,0,0,390,393,1,0,0,0,391,389,1,0,0,0,391,392,1,0,0,0,392,394,1,
        0,0,0,393,391,1,0,0,0,394,395,5,72,0,0,395,37,1,0,0,0,396,397,3,
        40,20,0,397,39,1,0,0,0,398,401,3,42,21,0,399,401,3,44,22,0,400,398,
        1,0,0,0,400,399,1,0,0,0,401,41,1,0,0,0,402,403,3,70,35,0,403,404,
        5,69,0,0,404,405,3,40,20,0,405,43,1,0,0,0,406,407,3,46,23,0,407,
        45,1,0,0,0,408,413,3,48,24,0,409,410,5,83,0,0,410,412,3,48,24,0,
        411,409,1,0,0,0,412,415,1,0,0,0,413,411,1,0,0,0,413,414,1,0,0,0,
        414,47,1,0,0,0,415,413,1,0,0,0,416,421,3,50,25,0,417,418,5,82,0,
        0,418,420,3,50,25,0,419,417,1,0,0,0,420,423,1,0,0,0,421,419,1,0,
        0,0,421,422,1,0,0,0,422,49,1,0,0,0,423,421,1,0,0,0,424,429,3,52,
        26,0,425,426,7,0,0,0,426,428,3,52,26,0,427,425,1,0,0,0,428,431,1,
        0,0,0,429,427,1,0,0,0,429,430,1,0,0,0,430,51,1,0,0,0,431,429,1,0,
        0,0,432,437,3,54,27,0,433,434,7,1,0,0,434,436,3,54,27,0,435,433,
        1,0,0,0,436,439,1,0,0,0,437,435,1,0,0,0,437,438,1,0,0,0,438,53,1,
        0,0,0,439,437,1,0,0,0,440,445,3,56,28,0,441,442,7,2,0,0,442,444,
        3,56,28,0,443,441,1,0,0,0,444,447,1,0,0,0,445,443,1,0,0,0,445,446,
        1,0,0,0,446,55,1,0,0,0,447,445,1,0,0,0,448,454,3,58,29,0,449,450,
        7,3,0,0,450,453,3,58,29,0,451,453,3,60,30,0,452,449,1,0,0,0,452,
        451,1,0,0,0,453,456,1,0,0,0,454,452,1,0,0,0,454,455,1,0,0,0,455,
        57,1,0,0,0,456,454,1,0,0,0,457,458,5,84,0,0,458,465,3,58,29,0,459,
        460,5,85,0,0,460,465,3,58,29,0,461,462,5,90,0,0,462,465,3,58,29,
        0,463,465,3,60,30,0,464,457,1,0,0,0,464,459,1,0,0,0,464,461,1,0,
        0,0,464,463,1,0,0,0,465,59,1,0,0,0,466,469,3,62,31,0,467,468,5,91,
        0,0,468,470,3,58,29,0,469,467,1,0,0,0,469,470,1,0,0,0,470,61,1,0,
        0,0,471,482,3,80,40,0,472,482,3,72,36,0,473,482,3,76,38,0,474,482,
        3,74,37,0,475,476,5,73,0,0,476,477,3,40,20,0,477,478,5,74,0,0,478,
        482,1,0,0,0,479,482,3,64,32,0,480,482,3,68,34,0,481,471,1,0,0,0,
        481,472,1,0,0,0,481,473,1,0,0,0,481,474,1,0,0,0,481,475,1,0,0,0,
        481,479,1,0,0,0,481,480,1,0,0,0,482,63,1,0,0,0,483,484,5,73,0,0,
        484,486,3,66,33,0,485,487,3,40,20,0,486,485,1,0,0,0,487,488,1,0,
        0,0,488,486,1,0,0,0,488,489,1,0,0,0,489,490,1,0,0,0,490,491,5,74,
        0,0,491,65,1,0,0,0,492,493,7,4,0,0,493,67,1,0,0,0,494,495,5,71,0,
        0,495,500,3,40,20,0,496,497,5,70,0,0,497,499,3,40,20,0,498,496,1,
        0,0,0,499,502,1,0,0,0,500,498,1,0,0,0,500,501,1,0,0,0,501,503,1,
        0,0,0,502,500,1,0,0,0,503,504,5,72,0,0,504,69,1,0,0,0,505,508,3,
        72,36,0,506,508,3,74,37,0,507,505,1,0,0,0,507,506,1,0,0,0,508,71,
        1,0,0,0,509,510,3,74,37,0,510,511,3,68,34,0,511,73,1,0,0,0,512,514,
        5,75,0,0,513,512,1,0,0,0,513,514,1,0,0,0,514,515,1,0,0,0,515,516,
        5,63,0,0,516,75,1,0,0,0,517,518,5,63,0,0,518,519,5,73,0,0,519,520,
        3,78,39,0,520,521,5,74,0,0,521,77,1,0,0,0,522,527,3,40,20,0,523,
        524,5,70,0,0,524,526,3,40,20,0,525,523,1,0,0,0,526,529,1,0,0,0,527,
        525,1,0,0,0,527,528,1,0,0,0,528,531,1,0,0,0,529,527,1,0,0,0,530,
        522,1,0,0,0,530,531,1,0,0,0,531,79,1,0,0,0,532,533,7,5,0,0,533,81,
        1,0,0,0,534,536,7,6,0,0,535,534,1,0,0,0,536,537,1,0,0,0,537,535,
        1,0,0,0,537,538,1,0,0,0,538,83,1,0,0,0,54,87,94,99,109,114,122,128,
        140,145,152,170,214,224,231,238,245,252,259,266,273,280,287,294,
        301,304,311,324,329,345,355,358,368,373,379,386,391,400,413,421,
        429,437,445,452,454,464,469,481,488,500,507,513,527,530,537
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!GeoTortueParser.__ATN) {
            GeoTortueParser.__ATN = new antlr.ATNDeserializer().deserialize(GeoTortueParser._serializedATN);
        }

        return GeoTortueParser.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(GeoTortueParser.literalNames, GeoTortueParser.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return GeoTortueParser.vocabulary;
    }

    private static readonly decisionsToDFA = GeoTortueParser._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class ProgramContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EOF(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.EOF, 0)!;
    }
    public terminator(): TerminatorContext[];
    public terminator(i: number): TerminatorContext | null;
    public terminator(i?: number): TerminatorContext[] | TerminatorContext | null {
        if (i === undefined) {
            return this.getRuleContexts(TerminatorContext);
        }

        return this.getRuleContext(i, TerminatorContext);
    }
    public statement(): StatementContext[];
    public statement(i: number): StatementContext | null;
    public statement(i?: number): StatementContext[] | StatementContext | null {
        if (i === undefined) {
            return this.getRuleContexts(StatementContext);
        }

        return this.getRuleContext(i, StatementContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_program;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProgram) {
             listener.enterProgram(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProgram) {
             listener.exitProgram(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProgram) {
            return visitor.visitProgram(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class StatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public structureStatement(): StructureStatementContext | null {
        return this.getRuleContext(0, StructureStatementContext);
    }
    public commandStatement(): CommandStatementContext | null {
        return this.getRuleContext(0, CommandStatementContext);
    }
    public expressionStatement(): ExpressionStatementContext | null {
        return this.getRuleContext(0, ExpressionStatementContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_statement;
    }
    public override copyFrom(ctx: StatementContext): void {
        super.copyFrom(ctx);
    }
}
export class ProcedureDefContext extends StatementContext {
    public constructor(ctx: StatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public procedureDefinition(): ProcedureDefinitionContext {
        return this.getRuleContext(0, ProcedureDefinitionContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureDef) {
             listener.enterProcedureDef(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureDef) {
             listener.exitProcedureDef(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureDef) {
            return visitor.visitProcedureDef(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ProcedureCallContext extends StatementContext {
    public constructor(ctx: StatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public procedureCallStatement(): ProcedureCallStatementContext {
        return this.getRuleContext(0, ProcedureCallStatementContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureCall) {
             listener.enterProcedureCall(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureCall) {
             listener.exitProcedureCall(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureCall) {
            return visitor.visitProcedureCall(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ProcedureDefinitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_PROCEDURE_START(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PROCEDURE_START, 0)!;
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public procedureBody(): ProcedureBodyContext {
        return this.getRuleContext(0, ProcedureBodyContext)!;
    }
    public GT_PROCEDURE_END(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PROCEDURE_END, 0)!;
    }
    public terminator(): TerminatorContext[];
    public terminator(i: number): TerminatorContext | null;
    public terminator(i?: number): TerminatorContext[] | TerminatorContext | null {
        if (i === undefined) {
            return this.getRuleContexts(TerminatorContext);
        }

        return this.getRuleContext(i, TerminatorContext);
    }
    public procedureParameter(): ProcedureParameterContext[];
    public procedureParameter(i: number): ProcedureParameterContext | null;
    public procedureParameter(i?: number): ProcedureParameterContext[] | ProcedureParameterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ProcedureParameterContext);
        }

        return this.getRuleContext(i, ProcedureParameterContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_procedureDefinition;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureDefinition) {
             listener.enterProcedureDefinition(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureDefinition) {
             listener.exitProcedureDefinition(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureDefinition) {
            return visitor.visitProcedureDefinition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ProcedureParameterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_procedureParameter;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureParameter) {
             listener.enterProcedureParameter(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureParameter) {
             listener.exitProcedureParameter(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureParameter) {
            return visitor.visitProcedureParameter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ProcedureBodyContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public statement(): StatementContext[];
    public statement(i: number): StatementContext | null;
    public statement(i?: number): StatementContext[] | StatementContext | null {
        if (i === undefined) {
            return this.getRuleContexts(StatementContext);
        }

        return this.getRuleContext(i, StatementContext);
    }
    public terminator(): TerminatorContext[];
    public terminator(i: number): TerminatorContext | null;
    public terminator(i?: number): TerminatorContext[] | TerminatorContext | null {
        if (i === undefined) {
            return this.getRuleContexts(TerminatorContext);
        }

        return this.getRuleContext(i, TerminatorContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_procedureBody;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureBody) {
             listener.enterProcedureBody(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureBody) {
             listener.exitProcedureBody(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureBody) {
            return visitor.visitProcedureBody(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CommandStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixedArityZeroCommandStatement(): FixedArityZeroCommandStatementContext | null {
        return this.getRuleContext(0, FixedArityZeroCommandStatementContext);
    }
    public fixedArityOneCommandStatement(): FixedArityOneCommandStatementContext | null {
        return this.getRuleContext(0, FixedArityOneCommandStatementContext);
    }
    public fixedArityTwoCommandStatement(): FixedArityTwoCommandStatementContext | null {
        return this.getRuleContext(0, FixedArityTwoCommandStatementContext);
    }
    public variableArityMarkerCommandStatement(): VariableArityMarkerCommandStatementContext | null {
        return this.getRuleContext(0, VariableArityMarkerCommandStatementContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_commandStatement;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterCommandStatement) {
             listener.enterCommandStatement(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitCommandStatement) {
             listener.exitCommandStatement(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitCommandStatement) {
            return visitor.visitCommandStatement(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class FixedArityZeroCommandStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_fixedArityZeroCommandStatement;
    }
    public override copyFrom(ctx: FixedArityZeroCommandStatementContext): void {
        super.copyFrom(ctx);
    }
}
export class ClearGraphicsContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_CLEAR_GRAPHICS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_CLEAR_GRAPHICS, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterClearGraphics) {
             listener.enterClearGraphics(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitClearGraphics) {
             listener.exitClearGraphics(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitClearGraphics) {
            return visitor.visitClearGraphics(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ResetContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_RESET(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RESET, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterReset) {
             listener.enterReset(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitReset) {
             listener.exitReset(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitReset) {
            return visitor.visitReset(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class HideTurtleContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_HIDE_TURTLE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_HIDE_TURTLE, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterHideTurtle) {
             listener.enterHideTurtle(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitHideTurtle) {
             listener.exitHideTurtle(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitHideTurtle) {
            return visitor.visitHideTurtle(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowTurtleContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_SHOW_TURTLE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_SHOW_TURTLE, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterShowTurtle) {
             listener.enterShowTurtle(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitShowTurtle) {
             listener.exitShowTurtle(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitShowTurtle) {
            return visitor.visitShowTurtle(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PenUpContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PEN_UP(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PEN_UP, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPenUp) {
             listener.enterPenUp(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPenUp) {
             listener.exitPenUp(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPenUp) {
            return visitor.visitPenUp(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PenDownContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PEN_DOWN(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PEN_DOWN, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPenDown) {
             listener.enterPenDown(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPenDown) {
             listener.exitPenDown(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPenDown) {
            return visitor.visitPenDown(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class CompassContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_COMPASS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_COMPASS, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterCompass) {
             listener.enterCompass(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitCompass) {
             listener.exitCompass(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitCompass) {
            return visitor.visitCompass(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class InitContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_INIT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_INIT, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterInit) {
             listener.enterInit(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitInit) {
             listener.exitInit(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitInit) {
            return visitor.visitInit(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class WaitContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_WAIT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_WAIT, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterWait) {
             listener.enterWait(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitWait) {
             listener.exitWait(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitWait) {
            return visitor.visitWait(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class StopContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_STOP(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_STOP, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterStop) {
             listener.enterStop(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitStop) {
             listener.exitStop(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitStop) {
            return visitor.visitStop(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class UndoDrawingContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_UNDO_DRAWING(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_UNDO_DRAWING, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterUndoDrawing) {
             listener.enterUndoDrawing(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitUndoDrawing) {
             listener.exitUndoDrawing(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitUndoDrawing) {
            return visitor.visitUndoDrawing(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class DrawPointContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_DRAW_POINT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_DRAW_POINT, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterDrawPoint) {
             listener.enterDrawPoint(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitDrawPoint) {
             listener.exitDrawPoint(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitDrawPoint) {
            return visitor.visitDrawPoint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class MirrorContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_MIRROR(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_MIRROR, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterMirror) {
             listener.enterMirror(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitMirror) {
             listener.exitMirror(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitMirror) {
            return visitor.visitMirror(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class WrapModeContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_WRAP(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_WRAP, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterWrapMode) {
             listener.enterWrapMode(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitWrapMode) {
             listener.exitWrapMode(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitWrapMode) {
            return visitor.visitWrapMode(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class WindowModeContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_WINDOW(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_WINDOW, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterWindowMode) {
             listener.enterWindowMode(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitWindowMode) {
             listener.exitWindowMode(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitWindowMode) {
            return visitor.visitWindowMode(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class FenceModeContext extends FixedArityZeroCommandStatementContext {
    public constructor(ctx: FixedArityZeroCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_FENCE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_FENCE, 0)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterFenceMode) {
             listener.enterFenceMode(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitFenceMode) {
             listener.exitFenceMode(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitFenceMode) {
            return visitor.visitFenceMode(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class FixedArityOneCommandStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_fixedArityOneCommandStatement;
    }
    public override copyFrom(ctx: FixedArityOneCommandStatementContext): void {
        super.copyFrom(ctx);
    }
}
export class MoveForwardContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_FORWARD(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_FORWARD, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterMoveForward) {
             listener.enterMoveForward(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitMoveForward) {
             listener.exitMoveForward(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitMoveForward) {
            return visitor.visitMoveForward(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class MoveBackwardContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_BACKWARD(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_BACKWARD, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterMoveBackward) {
             listener.enterMoveBackward(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitMoveBackward) {
             listener.exitMoveBackward(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitMoveBackward) {
            return visitor.visitMoveBackward(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class TurnRightContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_TURN_RIGHT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_TURN_RIGHT, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterTurnRight) {
             listener.enterTurnRight(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitTurnRight) {
             listener.exitTurnRight(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitTurnRight) {
            return visitor.visitTurnRight(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class TurnLeftContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_TURN_LEFT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_TURN_LEFT, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterTurnLeft) {
             listener.enterTurnLeft(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitTurnLeft) {
             listener.exitTurnLeft(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitTurnLeft) {
            return visitor.visitTurnLeft(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PenThicknessContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PEN_THICKNESS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PEN_THICKNESS, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPenThickness) {
             listener.enterPenThickness(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPenThickness) {
             listener.exitPenThickness(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPenThickness) {
            return visitor.visitPenThickness(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PenColorContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PEN_COLOR(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PEN_COLOR, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPenColor) {
             listener.enterPenColor(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPenColor) {
             listener.exitPenColor(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPenColor) {
            return visitor.visitPenColor(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class AimContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_AIM(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_AIM, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterAim) {
             listener.enterAim(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitAim) {
             listener.exitAim(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitAim) {
            return visitor.visitAim(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class MimicContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_MIMIC(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_MIMIC, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterMimic) {
             listener.enterMimic(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitMimic) {
             listener.exitMimic(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitMimic) {
            return visitor.visitMimic(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PauseContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PAUSE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PAUSE, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPause) {
             listener.enterPause(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPause) {
             listener.exitPause(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPause) {
            return visitor.visitPause(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateUpContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_UP(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_UP, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateUp) {
             listener.enterRotateUp(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateUp) {
             listener.exitRotateUp(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateUp) {
            return visitor.visitRotateUp(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateDownContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_DOWN(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_DOWN, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateDown) {
             listener.enterRotateDown(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateDown) {
             listener.exitRotateDown(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateDown) {
            return visitor.visitRotateDown(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateRightContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_RIGHT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_RIGHT, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateRight) {
             listener.enterRotateRight(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateRight) {
             listener.exitRotateRight(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateRight) {
            return visitor.visitRotateRight(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateLeftContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_LEFT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_LEFT, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateLeft) {
             listener.enterRotateLeft(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateLeft) {
             listener.exitRotateLeft(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateLeft) {
            return visitor.visitRotateLeft(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateXYContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_XY(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_XY, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateXY) {
             listener.enterRotateXY(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateXY) {
             listener.exitRotateXY(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateXY) {
            return visitor.visitRotateXY(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateXZContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_XZ(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_XZ, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateXZ) {
             listener.enterRotateXZ(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateXZ) {
             listener.exitRotateXZ(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateXZ) {
            return visitor.visitRotateXZ(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class RotateYZContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ROTATE_YZ(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ROTATE_YZ, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRotateYZ) {
             listener.enterRotateYZ(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRotateYZ) {
             listener.exitRotateYZ(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRotateYZ) {
            return visitor.visitRotateYZ(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class SnapshotContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_SNAPSHOT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_SNAPSHOT, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterSnapshot) {
             listener.enterSnapshot(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitSnapshot) {
             listener.exitSnapshot(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitSnapshot) {
            return visitor.visitSnapshot(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReturnContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_RETURN(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RETURN, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterReturn) {
             listener.enterReturn(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitReturn) {
             listener.exitReturn(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitReturn) {
            return visitor.visitReturn(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class DrawCircleContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_DRAW_CIRCLE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_DRAW_CIRCLE, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterDrawCircle) {
             listener.enterDrawCircle(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitDrawCircle) {
             listener.exitDrawCircle(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitDrawCircle) {
            return visitor.visitDrawCircle(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class FillContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_FILL(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_FILL, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterFill) {
             listener.enterFill(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitFill) {
             listener.exitFill(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitFill) {
            return visitor.visitFill(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ManipulateGraphContext extends FixedArityOneCommandStatementContext {
    public constructor(ctx: FixedArityOneCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_MANIPULATE_GRAPH(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_MANIPULATE_GRAPH, 0)!;
    }
    public commandArgument(): CommandArgumentContext {
        return this.getRuleContext(0, CommandArgumentContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterManipulateGraph) {
             listener.enterManipulateGraph(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitManipulateGraph) {
             listener.exitManipulateGraph(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitManipulateGraph) {
            return visitor.visitManipulateGraph(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class FixedArityTwoCommandStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_fixedArityTwoCommandStatement;
    }
    public override copyFrom(ctx: FixedArityTwoCommandStatementContext): void {
        super.copyFrom(ctx);
    }
}
export class DrawArcContext extends FixedArityTwoCommandStatementContext {
    public constructor(ctx: FixedArityTwoCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_DRAW_ARC(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_DRAW_ARC, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterDrawArc) {
             listener.enterDrawArc(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitDrawArc) {
             listener.exitDrawArc(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitDrawArc) {
            return visitor.visitDrawArc(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class VariableArityMarkerCommandStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_variableArityMarkerCommandStatement;
    }
    public override copyFrom(ctx: VariableArityMarkerCommandStatementContext): void {
        super.copyFrom(ctx);
    }
}
export class TeleportContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_TELEPORT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_TELEPORT, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterTeleport) {
             listener.enterTeleport(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitTeleport) {
             listener.exitTeleport(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitTeleport) {
            return visitor.visitTeleport(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class SelectContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_SELECT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_SELECT, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterSelect) {
             listener.enterSelect(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitSelect) {
             listener.exitSelect(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitSelect) {
            return visitor.visitSelect(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class DeleteContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_DELETE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_DELETE, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterDelete) {
             listener.enterDelete(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitDelete) {
             listener.exitDelete(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitDelete) {
            return visitor.visitDelete(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class DisplayContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_DISPLAY(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_DISPLAY, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterDisplay) {
             listener.enterDisplay(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitDisplay) {
             listener.exitDisplay(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitDisplay) {
            return visitor.visitDisplay(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class WriteContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_WRITE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_WRITE, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterWrite) {
             listener.enterWrite(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitWrite) {
             listener.exitWrite(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitWrite) {
            return visitor.visitWrite(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class SayContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_SAY(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_SAY, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterSay) {
             listener.enterSay(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitSay) {
             listener.exitSay(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitSay) {
            return visitor.visitSay(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExecuteContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_EXECUTE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_EXECUTE, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterExecute) {
             listener.enterExecute(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitExecute) {
             listener.exitExecute(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitExecute) {
            return visitor.visitExecute(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class PlayMusicContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_PLAY(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_PLAY, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPlayMusic) {
             listener.enterPlayMusic(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPlayMusic) {
             listener.exitPlayMusic(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPlayMusic) {
            return visitor.visitPlayMusic(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ScoreContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_SCORE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_SCORE, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterScore) {
             listener.enterScore(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitScore) {
             listener.exitScore(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitScore) {
            return visitor.visitScore(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConcertContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_CONCERT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_CONCERT, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterConcert) {
             listener.enterConcert(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitConcert) {
             listener.exitConcert(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitConcert) {
            return visitor.visitConcert(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class AskForValueContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_ASK_FOR_VALUE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ASK_FOR_VALUE, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterAskForValue) {
             listener.enterAskForValue(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitAskForValue) {
             listener.exitAskForValue(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitAskForValue) {
            return visitor.visitAskForValue(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
export class GlobalContext extends VariableArityMarkerCommandStatementContext {
    public constructor(ctx: VariableArityMarkerCommandStatementContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public GT_GLOBAL(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_GLOBAL, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterGlobal) {
             listener.enterGlobal(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitGlobal) {
             listener.exitGlobal(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitGlobal) {
            return visitor.visitGlobal(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class StructureStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public repeatBlock(): RepeatBlockContext | null {
        return this.getRuleContext(0, RepeatBlockContext);
    }
    public whileBlock(): WhileBlockContext | null {
        return this.getRuleContext(0, WhileBlockContext);
    }
    public ifBlock(): IfBlockContext | null {
        return this.getRuleContext(0, IfBlockContext);
    }
    public forEachBlock(): ForEachBlockContext | null {
        return this.getRuleContext(0, ForEachBlockContext);
    }
    public functionDef(): FunctionDefContext | null {
        return this.getRuleContext(0, FunctionDefContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_structureStatement;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterStructureStatement) {
             listener.enterStructureStatement(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitStructureStatement) {
             listener.exitStructureStatement(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitStructureStatement) {
            return visitor.visitStructureStatement(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class RepeatBlockContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_REPEAT(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_REPEAT, 0)!;
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public commandBlock(): CommandBlockContext {
        return this.getRuleContext(0, CommandBlockContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_repeatBlock;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRepeatBlock) {
             listener.enterRepeatBlock(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRepeatBlock) {
             listener.exitRepeatBlock(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRepeatBlock) {
            return visitor.visitRepeatBlock(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class WhileBlockContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_WHILE(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_WHILE, 0)!;
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public commandBlock(): CommandBlockContext {
        return this.getRuleContext(0, CommandBlockContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_whileBlock;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterWhileBlock) {
             listener.enterWhileBlock(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitWhileBlock) {
             listener.exitWhileBlock(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitWhileBlock) {
            return visitor.visitWhileBlock(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class IfBlockContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_IF(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IF, 0)!;
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public commandBlock(): CommandBlockContext[];
    public commandBlock(i: number): CommandBlockContext | null;
    public commandBlock(i?: number): CommandBlockContext[] | CommandBlockContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandBlockContext);
        }

        return this.getRuleContext(i, CommandBlockContext);
    }
    public GT_THEN(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_THEN, 0);
    }
    public GT_ELSE(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_ELSE, 0);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_ifBlock;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterIfBlock) {
             listener.enterIfBlock(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitIfBlock) {
             listener.exitIfBlock(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitIfBlock) {
            return visitor.visitIfBlock(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ForEachBlockContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_FOR_EACH(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_FOR_EACH, 0)!;
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public GT_IN_LIST(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_IN_LIST, 0);
    }
    public expression(): ExpressionContext[];
    public expression(i: number): ExpressionContext | null;
    public expression(i?: number): ExpressionContext[] | ExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }

        return this.getRuleContext(i, ExpressionContext);
    }
    public commandBlock(): CommandBlockContext {
        return this.getRuleContext(0, CommandBlockContext)!;
    }
    public GT_FROM(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_FROM, 0);
    }
    public GT_TO(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_TO, 0);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_forEachBlock;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterForEachBlock) {
             listener.enterForEachBlock(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitForEachBlock) {
             listener.exitForEachBlock(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitForEachBlock) {
            return visitor.visitForEachBlock(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class FunctionDefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_FUNCTION_DEF(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_FUNCTION_DEF, 0)!;
    }
    public GT_IDENTIFIER(): antlr.TerminalNode[];
    public GT_IDENTIFIER(i: number): antlr.TerminalNode | null;
    public GT_IDENTIFIER(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_IDENTIFIER);
    	} else {
    		return this.getToken(GeoTortueParser.GT_IDENTIFIER, i);
    	}
    }
    public GT_LEFT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_LEFT_PARENTHESIS, 0)!;
    }
    public GT_RIGHT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RIGHT_PARENTHESIS, 0)!;
    }
    public GT_ASSIGN(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ASSIGN, 0)!;
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public GT_COMMA(): antlr.TerminalNode[];
    public GT_COMMA(i: number): antlr.TerminalNode | null;
    public GT_COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_COMMA);
    	} else {
    		return this.getToken(GeoTortueParser.GT_COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_functionDef;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterFunctionDef) {
             listener.enterFunctionDef(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitFunctionDef) {
             listener.exitFunctionDef(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitFunctionDef) {
            return visitor.visitFunctionDef(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ProcedureCallStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public commandArgument(): CommandArgumentContext[];
    public commandArgument(i: number): CommandArgumentContext | null;
    public commandArgument(i?: number): CommandArgumentContext[] | CommandArgumentContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CommandArgumentContext);
        }

        return this.getRuleContext(i, CommandArgumentContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_procedureCallStatement;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterProcedureCallStatement) {
             listener.enterProcedureCallStatement(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitProcedureCallStatement) {
             listener.exitProcedureCallStatement(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitProcedureCallStatement) {
            return visitor.visitProcedureCallStatement(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CommandArgumentContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public commandBlock(): CommandBlockContext | null {
        return this.getRuleContext(0, CommandBlockContext);
    }
    public expression(): ExpressionContext | null {
        return this.getRuleContext(0, ExpressionContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_commandArgument;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterCommandArgument) {
             listener.enterCommandArgument(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitCommandArgument) {
             listener.exitCommandArgument(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitCommandArgument) {
            return visitor.visitCommandArgument(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CommandBlockContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_LEFT_SQUARE_BRACKET(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_LEFT_SQUARE_BRACKET, 0)!;
    }
    public GT_RIGHT_SQUARE_BRACKET(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RIGHT_SQUARE_BRACKET, 0)!;
    }
    public terminator(): TerminatorContext[];
    public terminator(i: number): TerminatorContext | null;
    public terminator(i?: number): TerminatorContext[] | TerminatorContext | null {
        if (i === undefined) {
            return this.getRuleContexts(TerminatorContext);
        }

        return this.getRuleContext(i, TerminatorContext);
    }
    public statement(): StatementContext[];
    public statement(i: number): StatementContext | null;
    public statement(i?: number): StatementContext[] | StatementContext | null {
        if (i === undefined) {
            return this.getRuleContexts(StatementContext);
        }

        return this.getRuleContext(i, StatementContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_commandBlock;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterCommandBlock) {
             listener.enterCommandBlock(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitCommandBlock) {
             listener.exitCommandBlock(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitCommandBlock) {
            return visitor.visitCommandBlock(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ExpressionStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_expressionStatement;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterExpressionStatement) {
             listener.enterExpressionStatement(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitExpressionStatement) {
             listener.exitExpressionStatement(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitExpressionStatement) {
            return visitor.visitExpressionStatement(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public rightExpression(): RightExpressionContext {
        return this.getRuleContext(0, RightExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_expression;
    }
    public override copyFrom(ctx: ExpressionContext): void {
        super.copyFrom(ctx);
    }
}
export class VarAssignmentContext extends ExpressionContext {
    public constructor(ctx: ExpressionContext) {
        super(ctx.parent, ctx.invokingState);
        super.copyFrom(ctx);
    }
    public assignExpression(): AssignExpressionContext {
        return this.getRuleContext(0, AssignExpressionContext)!;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterVarAssignment) {
             listener.enterVarAssignment(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitVarAssignment) {
             listener.exitVarAssignment(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitVarAssignment) {
            return visitor.visitVarAssignment(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class AssignExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public lValue(): LValueContext {
        return this.getRuleContext(0, LValueContext)!;
    }
    public GT_ASSIGN(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_ASSIGN, 0)!;
    }
    public expression(): ExpressionContext {
        return this.getRuleContext(0, ExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_assignExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterAssignExpression) {
             listener.enterAssignExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitAssignExpression) {
             listener.exitAssignExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitAssignExpression) {
            return visitor.visitAssignExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class RightExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public logicalOrExpression(): LogicalOrExpressionContext {
        return this.getRuleContext(0, LogicalOrExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_rightExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRightExpression) {
             listener.enterRightExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRightExpression) {
             listener.exitRightExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRightExpression) {
            return visitor.visitRightExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class LogicalOrExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public logicalAndExpression(): LogicalAndExpressionContext[];
    public logicalAndExpression(i: number): LogicalAndExpressionContext | null;
    public logicalAndExpression(i?: number): LogicalAndExpressionContext[] | LogicalAndExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(LogicalAndExpressionContext);
        }

        return this.getRuleContext(i, LogicalAndExpressionContext);
    }
    public GT_LOGICAL_OR(): antlr.TerminalNode[];
    public GT_LOGICAL_OR(i: number): antlr.TerminalNode | null;
    public GT_LOGICAL_OR(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_LOGICAL_OR);
    	} else {
    		return this.getToken(GeoTortueParser.GT_LOGICAL_OR, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_logicalOrExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterLogicalOrExpression) {
             listener.enterLogicalOrExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitLogicalOrExpression) {
             listener.exitLogicalOrExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitLogicalOrExpression) {
            return visitor.visitLogicalOrExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class LogicalAndExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public equalityExpression(): EqualityExpressionContext[];
    public equalityExpression(i: number): EqualityExpressionContext | null;
    public equalityExpression(i?: number): EqualityExpressionContext[] | EqualityExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(EqualityExpressionContext);
        }

        return this.getRuleContext(i, EqualityExpressionContext);
    }
    public GT_LOGICAL_AND(): antlr.TerminalNode[];
    public GT_LOGICAL_AND(i: number): antlr.TerminalNode | null;
    public GT_LOGICAL_AND(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_LOGICAL_AND);
    	} else {
    		return this.getToken(GeoTortueParser.GT_LOGICAL_AND, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_logicalAndExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterLogicalAndExpression) {
             listener.enterLogicalAndExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitLogicalAndExpression) {
             listener.exitLogicalAndExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitLogicalAndExpression) {
            return visitor.visitLogicalAndExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class EqualityExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public relationalExpression(): RelationalExpressionContext[];
    public relationalExpression(i: number): RelationalExpressionContext | null;
    public relationalExpression(i?: number): RelationalExpressionContext[] | RelationalExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(RelationalExpressionContext);
        }

        return this.getRuleContext(i, RelationalExpressionContext);
    }
    public GT_NOT_EQUAL(): antlr.TerminalNode[];
    public GT_NOT_EQUAL(i: number): antlr.TerminalNode | null;
    public GT_NOT_EQUAL(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_NOT_EQUAL);
    	} else {
    		return this.getToken(GeoTortueParser.GT_NOT_EQUAL, i);
    	}
    }
    public GT_EQUAL(): antlr.TerminalNode[];
    public GT_EQUAL(i: number): antlr.TerminalNode | null;
    public GT_EQUAL(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_EQUAL);
    	} else {
    		return this.getToken(GeoTortueParser.GT_EQUAL, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_equalityExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterEqualityExpression) {
             listener.enterEqualityExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitEqualityExpression) {
             listener.exitEqualityExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitEqualityExpression) {
            return visitor.visitEqualityExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class RelationalExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public additiveExpression(): AdditiveExpressionContext[];
    public additiveExpression(i: number): AdditiveExpressionContext | null;
    public additiveExpression(i?: number): AdditiveExpressionContext[] | AdditiveExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(AdditiveExpressionContext);
        }

        return this.getRuleContext(i, AdditiveExpressionContext);
    }
    public GT_LESS_THAN(): antlr.TerminalNode[];
    public GT_LESS_THAN(i: number): antlr.TerminalNode | null;
    public GT_LESS_THAN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_LESS_THAN);
    	} else {
    		return this.getToken(GeoTortueParser.GT_LESS_THAN, i);
    	}
    }
    public GT_GREATER_THAN(): antlr.TerminalNode[];
    public GT_GREATER_THAN(i: number): antlr.TerminalNode | null;
    public GT_GREATER_THAN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_GREATER_THAN);
    	} else {
    		return this.getToken(GeoTortueParser.GT_GREATER_THAN, i);
    	}
    }
    public GT_LESS_OR_EQUAL(): antlr.TerminalNode[];
    public GT_LESS_OR_EQUAL(i: number): antlr.TerminalNode | null;
    public GT_LESS_OR_EQUAL(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_LESS_OR_EQUAL);
    	} else {
    		return this.getToken(GeoTortueParser.GT_LESS_OR_EQUAL, i);
    	}
    }
    public GT_GREATER_OR_EQUAL(): antlr.TerminalNode[];
    public GT_GREATER_OR_EQUAL(i: number): antlr.TerminalNode | null;
    public GT_GREATER_OR_EQUAL(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_GREATER_OR_EQUAL);
    	} else {
    		return this.getToken(GeoTortueParser.GT_GREATER_OR_EQUAL, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_relationalExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterRelationalExpression) {
             listener.enterRelationalExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitRelationalExpression) {
             listener.exitRelationalExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitRelationalExpression) {
            return visitor.visitRelationalExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class AdditiveExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public multiplicativeExpression(): MultiplicativeExpressionContext[];
    public multiplicativeExpression(i: number): MultiplicativeExpressionContext | null;
    public multiplicativeExpression(i?: number): MultiplicativeExpressionContext[] | MultiplicativeExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(MultiplicativeExpressionContext);
        }

        return this.getRuleContext(i, MultiplicativeExpressionContext);
    }
    public GT_PLUS(): antlr.TerminalNode[];
    public GT_PLUS(i: number): antlr.TerminalNode | null;
    public GT_PLUS(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_PLUS);
    	} else {
    		return this.getToken(GeoTortueParser.GT_PLUS, i);
    	}
    }
    public GT_MINUS(): antlr.TerminalNode[];
    public GT_MINUS(i: number): antlr.TerminalNode | null;
    public GT_MINUS(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_MINUS);
    	} else {
    		return this.getToken(GeoTortueParser.GT_MINUS, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_additiveExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterAdditiveExpression) {
             listener.enterAdditiveExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitAdditiveExpression) {
             listener.exitAdditiveExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitAdditiveExpression) {
            return visitor.visitAdditiveExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class MultiplicativeExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public unaryExpression(): UnaryExpressionContext[];
    public unaryExpression(i: number): UnaryExpressionContext | null;
    public unaryExpression(i?: number): UnaryExpressionContext[] | UnaryExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(UnaryExpressionContext);
        }

        return this.getRuleContext(i, UnaryExpressionContext);
    }
    public powerExpression(): PowerExpressionContext[];
    public powerExpression(i: number): PowerExpressionContext | null;
    public powerExpression(i?: number): PowerExpressionContext[] | PowerExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(PowerExpressionContext);
        }

        return this.getRuleContext(i, PowerExpressionContext);
    }
    public GT_MULTIPLY(): antlr.TerminalNode[];
    public GT_MULTIPLY(i: number): antlr.TerminalNode | null;
    public GT_MULTIPLY(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_MULTIPLY);
    	} else {
    		return this.getToken(GeoTortueParser.GT_MULTIPLY, i);
    	}
    }
    public GT_DOT(): antlr.TerminalNode[];
    public GT_DOT(i: number): antlr.TerminalNode | null;
    public GT_DOT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_DOT);
    	} else {
    		return this.getToken(GeoTortueParser.GT_DOT, i);
    	}
    }
    public GT_CROSS_PRODUCT(): antlr.TerminalNode[];
    public GT_CROSS_PRODUCT(i: number): antlr.TerminalNode | null;
    public GT_CROSS_PRODUCT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_CROSS_PRODUCT);
    	} else {
    		return this.getToken(GeoTortueParser.GT_CROSS_PRODUCT, i);
    	}
    }
    public GT_DIVIDE(): antlr.TerminalNode[];
    public GT_DIVIDE(i: number): antlr.TerminalNode | null;
    public GT_DIVIDE(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_DIVIDE);
    	} else {
    		return this.getToken(GeoTortueParser.GT_DIVIDE, i);
    	}
    }
    public GT_MODULO(): antlr.TerminalNode[];
    public GT_MODULO(i: number): antlr.TerminalNode | null;
    public GT_MODULO(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_MODULO);
    	} else {
    		return this.getToken(GeoTortueParser.GT_MODULO, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_multiplicativeExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterMultiplicativeExpression) {
             listener.enterMultiplicativeExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitMultiplicativeExpression) {
             listener.exitMultiplicativeExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitMultiplicativeExpression) {
            return visitor.visitMultiplicativeExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class UnaryExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_PLUS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_PLUS, 0);
    }
    public unaryExpression(): UnaryExpressionContext | null {
        return this.getRuleContext(0, UnaryExpressionContext);
    }
    public GT_MINUS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_MINUS, 0);
    }
    public GT_LOGICAL_NOT(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LOGICAL_NOT, 0);
    }
    public powerExpression(): PowerExpressionContext | null {
        return this.getRuleContext(0, PowerExpressionContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_unaryExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterUnaryExpression) {
             listener.enterUnaryExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitUnaryExpression) {
             listener.exitUnaryExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitUnaryExpression) {
            return visitor.visitUnaryExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class PowerExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public unaryExpressionWithoutSign(): UnaryExpressionWithoutSignContext {
        return this.getRuleContext(0, UnaryExpressionWithoutSignContext)!;
    }
    public GT_POWER(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_POWER, 0);
    }
    public unaryExpression(): UnaryExpressionContext | null {
        return this.getRuleContext(0, UnaryExpressionContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_powerExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterPowerExpression) {
             listener.enterPowerExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitPowerExpression) {
             listener.exitPowerExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitPowerExpression) {
            return visitor.visitPowerExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class UnaryExpressionWithoutSignContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public constant(): ConstantContext | null {
        return this.getRuleContext(0, ConstantContext);
    }
    public arrayAccess(): ArrayAccessContext | null {
        return this.getRuleContext(0, ArrayAccessContext);
    }
    public functionCall(): FunctionCallContext | null {
        return this.getRuleContext(0, FunctionCallContext);
    }
    public variable(): VariableContext | null {
        return this.getRuleContext(0, VariableContext);
    }
    public GT_LEFT_PARENTHESIS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LEFT_PARENTHESIS, 0);
    }
    public expression(): ExpressionContext | null {
        return this.getRuleContext(0, ExpressionContext);
    }
    public GT_RIGHT_PARENTHESIS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_RIGHT_PARENTHESIS, 0);
    }
    public sExpression(): SExpressionContext | null {
        return this.getRuleContext(0, SExpressionContext);
    }
    public listLiteral(): ListLiteralContext | null {
        return this.getRuleContext(0, ListLiteralContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_unaryExpressionWithoutSign;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterUnaryExpressionWithoutSign) {
             listener.enterUnaryExpressionWithoutSign(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitUnaryExpressionWithoutSign) {
             listener.exitUnaryExpressionWithoutSign(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitUnaryExpressionWithoutSign) {
            return visitor.visitUnaryExpressionWithoutSign(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class SExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_LEFT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_LEFT_PARENTHESIS, 0)!;
    }
    public sExpressionOperator(): SExpressionOperatorContext {
        return this.getRuleContext(0, SExpressionOperatorContext)!;
    }
    public GT_RIGHT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RIGHT_PARENTHESIS, 0)!;
    }
    public expression(): ExpressionContext[];
    public expression(i: number): ExpressionContext | null;
    public expression(i?: number): ExpressionContext[] | ExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }

        return this.getRuleContext(i, ExpressionContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_sExpression;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterSExpression) {
             listener.enterSExpression(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitSExpression) {
             listener.exitSExpression(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitSExpression) {
            return visitor.visitSExpression(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class SExpressionOperatorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_PLUS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_PLUS, 0);
    }
    public GT_MINUS(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_MINUS, 0);
    }
    public GT_MULTIPLY(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_MULTIPLY, 0);
    }
    public GT_DIVIDE(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_DIVIDE, 0);
    }
    public GT_MODULO(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_MODULO, 0);
    }
    public GT_POWER(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_POWER, 0);
    }
    public GT_EQUAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_EQUAL, 0);
    }
    public GT_NOT_EQUAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_NOT_EQUAL, 0);
    }
    public GT_LESS_THAN(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LESS_THAN, 0);
    }
    public GT_LESS_OR_EQUAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LESS_OR_EQUAL, 0);
    }
    public GT_GREATER_THAN(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_GREATER_THAN, 0);
    }
    public GT_GREATER_OR_EQUAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_GREATER_OR_EQUAL, 0);
    }
    public GT_LOGICAL_AND(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LOGICAL_AND, 0);
    }
    public GT_LOGICAL_OR(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LOGICAL_OR, 0);
    }
    public GT_LOGICAL_NOT(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_LOGICAL_NOT, 0);
    }
    public GT_IDENTIFIER(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_sExpressionOperator;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterSExpressionOperator) {
             listener.enterSExpressionOperator(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitSExpressionOperator) {
             listener.exitSExpressionOperator(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitSExpressionOperator) {
            return visitor.visitSExpressionOperator(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ListLiteralContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_LEFT_SQUARE_BRACKET(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_LEFT_SQUARE_BRACKET, 0)!;
    }
    public expression(): ExpressionContext[];
    public expression(i: number): ExpressionContext | null;
    public expression(i?: number): ExpressionContext[] | ExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }

        return this.getRuleContext(i, ExpressionContext);
    }
    public GT_RIGHT_SQUARE_BRACKET(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RIGHT_SQUARE_BRACKET, 0)!;
    }
    public GT_COMMA(): antlr.TerminalNode[];
    public GT_COMMA(i: number): antlr.TerminalNode | null;
    public GT_COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_COMMA);
    	} else {
    		return this.getToken(GeoTortueParser.GT_COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_listLiteral;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterListLiteral) {
             listener.enterListLiteral(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitListLiteral) {
             listener.exitListLiteral(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitListLiteral) {
            return visitor.visitListLiteral(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class LValueContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public arrayAccess(): ArrayAccessContext | null {
        return this.getRuleContext(0, ArrayAccessContext);
    }
    public variable(): VariableContext | null {
        return this.getRuleContext(0, VariableContext);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_lValue;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterLValue) {
             listener.enterLValue(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitLValue) {
             listener.exitLValue(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitLValue) {
            return visitor.visitLValue(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ArrayAccessContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public variable(): VariableContext {
        return this.getRuleContext(0, VariableContext)!;
    }
    public listLiteral(): ListLiteralContext {
        return this.getRuleContext(0, ListLiteralContext)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_arrayAccess;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterArrayAccess) {
             listener.enterArrayAccess(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitArrayAccess) {
             listener.exitArrayAccess(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitArrayAccess) {
            return visitor.visitArrayAccess(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class VariableContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public GT_COLON(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_COLON, 0);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_variable;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterVariable) {
             listener.enterVariable(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitVariable) {
             listener.exitVariable(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitVariable) {
            return visitor.visitVariable(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class FunctionCallContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_IDENTIFIER(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_IDENTIFIER, 0)!;
    }
    public GT_LEFT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_LEFT_PARENTHESIS, 0)!;
    }
    public argumentList(): ArgumentListContext {
        return this.getRuleContext(0, ArgumentListContext)!;
    }
    public GT_RIGHT_PARENTHESIS(): antlr.TerminalNode {
        return this.getToken(GeoTortueParser.GT_RIGHT_PARENTHESIS, 0)!;
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_functionCall;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterFunctionCall) {
             listener.enterFunctionCall(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitFunctionCall) {
             listener.exitFunctionCall(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitFunctionCall) {
            return visitor.visitFunctionCall(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ArgumentListContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public expression(): ExpressionContext[];
    public expression(i: number): ExpressionContext | null;
    public expression(i?: number): ExpressionContext[] | ExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }

        return this.getRuleContext(i, ExpressionContext);
    }
    public GT_COMMA(): antlr.TerminalNode[];
    public GT_COMMA(i: number): antlr.TerminalNode | null;
    public GT_COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_COMMA);
    	} else {
    		return this.getToken(GeoTortueParser.GT_COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_argumentList;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterArgumentList) {
             listener.enterArgumentList(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitArgumentList) {
             listener.exitArgumentList(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitArgumentList) {
            return visitor.visitArgumentList(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class ConstantContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_STRING_LITERAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_STRING_LITERAL, 0);
    }
    public GT_INTEGER_LITERAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_INTEGER_LITERAL, 0);
    }
    public GT_FLOATING_POINT_LITERAL(): antlr.TerminalNode | null {
        return this.getToken(GeoTortueParser.GT_FLOATING_POINT_LITERAL, 0);
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_constant;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterConstant) {
             listener.enterConstant(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitConstant) {
             listener.exitConstant(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitConstant) {
            return visitor.visitConstant(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class TerminatorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public GT_STATEMENT_SEPARATOR(): antlr.TerminalNode[];
    public GT_STATEMENT_SEPARATOR(i: number): antlr.TerminalNode | null;
    public GT_STATEMENT_SEPARATOR(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_STATEMENT_SEPARATOR);
    	} else {
    		return this.getToken(GeoTortueParser.GT_STATEMENT_SEPARATOR, i);
    	}
    }
    public GT_NEW_LINE(): antlr.TerminalNode[];
    public GT_NEW_LINE(i: number): antlr.TerminalNode | null;
    public GT_NEW_LINE(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(GeoTortueParser.GT_NEW_LINE);
    	} else {
    		return this.getToken(GeoTortueParser.GT_NEW_LINE, i);
    	}
    }
    public override get ruleIndex(): number {
        return GeoTortueParser.RULE_terminator;
    }
    public override enterRule(listener: GeoTortueParserListener): void {
        if(listener.enterTerminator) {
             listener.enterTerminator(this);
        }
    }
    public override exitRule(listener: GeoTortueParserListener): void {
        if(listener.exitTerminator) {
             listener.exitTerminator(this);
        }
    }
    public override accept<Result>(visitor: GeoTortueParserVisitor<Result>): Result | null {
        if (visitor.visitTerminator) {
            return visitor.visitTerminator(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
